// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFLSURBVHgBnZLfTcMwEMbv7Lhx/RQ2sASuEC+UDdoNwgSUDViBDWCCZgPYoGWC8ogEEt6APiGranLYSaiqJqmqfJJj6/78fPlkhD0liU6cEykA6ipSLJ37WsIR4f9BqfOUcj73keSgxhJsps5Z2wZgu+aCv9TEx20e3RCwKUN69iGNJFZCmDF0aShH32FJqfVhLjT6HA2lWbQ2KzVKQ4GUZtZ5wdA8VTXNC1hRQDlansN7F4CI1zkxaQCIcA0ni9sGADEv6Zxj2tXGoJhUJ2dbC0oTY/PT5nQcXzzUHs3beqPw2eZ0GzFcRBxWnJvMh97q/B0CTqop2rV7SFJeaobFKxFc7xcQUMYAkUoYZb/u874xQfl37sP6bSzElV9bHWKDwWa5XtvSZCVHHoYzJQ0cQk6Wh2TBD9XhRy8IQg8FSPAklpsz6Ktgetj/ANwtaoEESpAOAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.lightTheme {
  /* Style the scrollbar thumb */
  /* Style the scrollbar on hover */
  /* Style the scrollbar thumb */
  /* Style the scrollbar on hover */
  /* Rounded sliders */
  /* width */
  /* Track */
  /* Handle */
  /* Handle on hover */
  /* for actions dropdown */
}
.lightTheme text {
  fill: black !important;
}
.lightTheme .main-wrapper {
  transition: all 0.25s ease-in;
  overflow: hidden;
  position: relative;
  margin: 0;
  max-height: 100vh;
  padding: 0;
  background: var(--foundation-neutral-neutral-200, #EFF3F9);
  min-height: 100vh;
  transition: all 0.2s ease-in-out;
}
.lightTheme .content-body {
  margin-left: 15rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
  transition: margin-left 0.4s ease;
}
.lightTheme .todo {
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  z-index: 1;
  /* popover */
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
}
.lightTheme .text-custom {
  color: var(--text-high-emphasis, #090826);
}
.lightTheme .celVQH {
  overflow-y: auto;
  max-height: 28vh;
}
@media (min-width: 1600px) {
  .lightTheme .celVQH {
    overflow-y: auto;
    max-height: 45vh;
  }
  .lightTheme .permission-page {
    overflow: scroll;
    height: 55vh;
  }
}
.lightTheme .content-body-collapse {
  margin-left: 6rem;
  margin-bottom: 1rem;
  margin-right: 1rem;
  transition: margin-left 0.4s ease;
}
.lightTheme .button-toggle {
  /* margin-right: -1.8rem; */
  position: absolute;
  right: -10px;
  bottom: -25px;
}
.lightTheme .user-img {
  display: block;
  width: 30px;
  height: 30px;
  object-fit: cover;
}
.lightTheme .nav-options-nested-option {
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-radius: 14px;
  font-family: Inter;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  margin-top: -45px;
  margin-bottom: 15px;
  margin-left: 39px;
}
.lightTheme .activeOption {
  border-radius: 14px;
  background: var(--primary);
  color: black;
  /* background: var(--primary-opactiy-20); */
  /* color: #333; */
  /* background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzI1NzlfNzc2MjAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjU3OV83NzYyMCkiPgo8cGF0aCBkPSJNOC4yMjkxNyAxMS45Mzc1TDEzLjcyOTIgNi40NTgzNEMxMy44ODE5IDYuMzA1NTYgMTQuMDU1NiA2LjIzMjY0IDE0LjI1IDYuMjM5NTlDMTQuNDQ0NCA2LjI0NjUzIDE0LjYxODEgNi4zMjYzOSAxNC43NzA4IDYuNDc5MTdDMTQuOTIzNiA2LjYzMTk1IDE1IDYuODA1NTYgMTUgNy4wMDAwMUMxNSA3LjE5NDQ1IDE0LjkyMzYgNy4zNjgwNiAxNC43NzA4IDcuNTIwODRMOC43NzA4MyAxMy41MjA4QzguNjE4MDYgMTMuNjczNiA4LjQ0MDk3IDEzLjc1IDguMjM5NTggMTMuNzVDOC4wMzgxOSAxMy43NSA3Ljg2MTExIDEzLjY3MzYgNy43MDgzMyAxMy41MjA4TDUuMjI5MTcgMTEuMDQxN0M1LjA3NjM5IDEwLjg4ODkgNSAxMC43MTUzIDUgMTAuNTIwOEM1IDEwLjMyNjQgNS4wNzYzOSAxMC4xNTI4IDUuMjI5MTcgMTBDNS4zODE5NCA5Ljg0NzIzIDUuNTU1NTYgOS43NzA4NCA1Ljc1IDkuNzcwODRDNS45NDQ0NCA5Ljc3MDg0IDYuMTE4MDYgOS44NDcyMyA2LjI3MDgzIDEwTDguMjI5MTcgMTEuOTM3NVoiIGZpbGw9IiMwOTA4MjYiLz4KPC9nPgo8L3N2Zz4K); */
  background-repeat: no-repeat;
  background-position: left;
}
.lightTheme .nav-options {
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-radius: 14px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .nav-options-hovered {
  color: black;
  background: var(--primary);
  border-radius: 14px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  width: 11.9rem;
}
.lightTheme .nav-options:hover {
  background: var(--primary);
  color: #002d72;
  font-weight: 600;
}
.lightTheme .nav-options:active {
  background: var(--primary);
  color: #002d72;
  font-weight: 600;
}
.lightTheme .nav-options:focus {
  background: var(--primary);
  color: #002d72;
  font-weight: 600;
}
.lightTheme .toggleSwitch {
  background: var(--foundation-neutral-neutral-500, #DCE4F1);
}
.lightTheme .nav-options-nested {
  color: var(--text-white-high-emphasis, #FCFCFE);
  display: flex;
  justify-content: space-between;
  border-radius: 14px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .nav-options-nested:hover {
  background: var(--primary);
  color: black;
  font-weight: 600;
}
.lightTheme .banner {
  margin: 1rem;
  margin-left: 15rem;
  background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);
}
.lightTheme .banner-collapse {
  margin: 1rem;
  margin-left: 6rem;
  background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);
}
.lightTheme .txt-title {
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Heading 5/Bold */
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 28.8px */
}
.lightTheme .table-custom {
  background: white;
  height: 89vh;
  border-radius: 12px;
}
.lightTheme .btn-banner {
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: var(--foundation-secondary-secondary-400, var(--primary));
  box-shadow: 0px 10px 31px 0px var(--primary-opactiy-40);
  color: #323146;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .headerTop {
  margin-left: 12rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-bottom: 1px solid #E3E9F4;
}
.lightTheme .headerTop-collapse {
  margin-left: 4rem;
  border-bottom: 1px solid #E3E9F4;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.lightTheme .fa-circle {
  font-size: 8px;
}
.lightTheme .headerSecond {
  margin-left: 14rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lightTheme .headerSecond-collapse {
  margin-left: 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lightTheme .image-logo {
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .fa-lock {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  font-size: 10px;
}
.lightTheme .image-logo-second {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Heading 5/Bold */
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 28.8px */
}
.lightTheme .groupid {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.lightTheme .bell {
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .sub-grp {
  border-radius: 14px;
  border: 2px solid var(--primary);
  background: var(--foundation-secondary-secondary-400, var(--primary));
  color: var(--text-high-emphasis, #090826);
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.lightTheme .delete-obj {
  background: var(--Error-error-button-enabled, #FF6969);
  box-shadow: 0px 10px 31px 0px rgba(255, 105, 105, 0.4);
  font-weight: 600;
}
.lightTheme .sub-grp:hover {
  background: var(--secondary-300);
}
.lightTheme .notificationcard {
  position: absolute;
  /* bottom:0; */
  top: 18px;
  right: 0;
  z-index: 1000;
  width: 300px;
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  /* popover */
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
}
.lightTheme .bgOne {
  background: var(--foundation-neutral-neutral-500, #DCE4F1);
}
.lightTheme .notification {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Large/Regular */
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
  z-index: 100000000;
}
.lightTheme .notification-card {
  border-top: 1px solid #E3E9F4;
}
.lightTheme .notification-card:hover {
  border-radius: 14px;
  background: var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .notification-img {
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  height: 40px;
  min-width: 40px;
}
.lightTheme .notification-heading {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Heading 6/Bold */
  font-family: Inter;
  text-align: left;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
}
.lightTheme .notification-description {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  text-align: left;
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.lightTheme .profile {
  z-index: 1000;
}
.lightTheme .profile-name {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .isactive {
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.lightTheme .profileCards {
  border-top: 1px solid #E3E9F4;
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.lightTheme .profilehover:hover {
  border-radius: 14px;
  background: var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .profileCards {
  display: flex;
  flex-direction: column;
}
.lightTheme .lffUrX:not(:last-of-type) {
  border: none !important;
}
.lightTheme .tab {
  border-radius: 14px;
  color: var(--text-high-emphasis);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 18.2px */
  background-color: var(--secondary-50);
  position: relative;
}
.lightTheme .type-roles {
  display: flex;
  padding: 4px 6px 4px 7px;
  align-items: center;
  justify-content: space-between;
  border-radius: 54px;
  border: 2px solid #C8CFDB;
  background: #E3E9F4;
  color: #090826;
  width: 129px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .tab.form {
  color: var(--secondary-500);
}
.lightTheme .tab::before {
  content: "";
  position: absolute;
  height: 4px;
  bottom: 0;
  border-radius: 20px;
  width: 70%;
  align-self: center;
  background-color: var(--secondary-500);
}
.lightTheme .tab.form::before {
  position: absolute;
  height: 4px;
  bottom: 0;
  border-radius: 20px;
  width: 70%;
  align-self: center;
  background-color: var(--secondary-50);
}
.lightTheme .tab-unactive {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  align-self: flex-start;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
}
.lightTheme input:focus {
  padding: none;
  outline: none !important;
}
.lightTheme .search-input::placeholder {
  /* Typography/Body/Default/Bold */ /* 16.8px */
  text-align: right;
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
}
.lightTheme .search-input, .lightTheme .custom-input {
  padding-right: 20px;
  border-radius: 14px;
  border: 2px solid var(--main-neutral-neutral-400, #E3E9F4);
  font-size: 0.8rem;
}
.lightTheme .fa-chevron-down {
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
}
.lightTheme .text-style {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 16.8px */
}
.lightTheme .iGDrkx {
  min-height: 0px !important;
  padding: 0 !important;
}
.lightTheme .fa-chevron-right {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
}
.lightTheme .lffUrX {
  min-height: 60px !important;
}
.lightTheme .text-heading {
  color: var(--text-high-emphasis, #090826);
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  word-break: normal !important;
  max-width: 6vw;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}
.lightTheme .desc-box {
  max-width: 14vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lightTheme .text-detail {
  color: var(--text-high-emphasis, #090826);
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .type-department {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid rgba(255, 146, 81, 0.5);
  background: rgba(255, 146, 81, 0.2);
  color: var(--foundation-orange-orange-800, #8C502D);
  padding: 4px 16px 4px 12px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .type-initiated {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid var(--secondary-300);
  background: #d4ebf2;
  color: #3590ae;
  padding: 4px 16px 4px 12px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .type-project {
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid rgba(157, 110, 248, 0.5);
  background: rgba(157, 110, 248, 0.2);
  color: var(--foundation-purple-purple-800, #563D88);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .type-Client {
  cursor: pointer;
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid rgba(106, 218, 0, 0.5);
  background: rgba(106, 218, 0, 0.2);
  color: var(--foundation-green-green-800, #3A7800);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .type-pending-provision {
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid rgba(246, 182, 55, 0.5019607843);
  background: rgba(246, 182, 55, 0.2);
  color: #87641E;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .type-requested {
  display: flex;
  padding: 4px 16px 4px 12px;
  align-items: center;
  gap: 8px;
  border-radius: 54px;
  border: 2px solid var(--secondary-300) 80;
  background: rgba(246, 182, 55, 0.2);
  color: #87641E;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .folder {
  text-align: center; /* 19.2px */
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .setting {
  color: var(--text-high-emphasis, #090826);
  width: 120px;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
}
.lightTheme .member {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  text-align: center;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
}
.lightTheme .folder-0 {
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
}
.lightTheme .setting-0 {
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));
  text-align: center;
  width: 120px;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
}
.lightTheme .cQAWmj {
  /* height: 20px!important; */
  min-height: 0px !important;
}
.lightTheme .lhMoHC {
  min-width: 50px !important;
}
.lightTheme .lffUrX:hover {
  background-color: #F1F1F4 !important;
  border-radius: 14px !important;
}
.lightTheme .Navheader {
  width: 13.7rem;
  transition: width 0.4s ease;
  background: #002d72;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 9;
}
.lightTheme .Navheader-collapse {
  width: 5rem;
  transition: width 0.4s ease;
  background: #002d72;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1000000000;
}
.lightTheme .under-dev-img {
  height: 80vh;
  width: 650px;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0.35;
}
.lightTheme .under-dev {
  font-size: 25px;
  opacity: 0.35;
}
.lightTheme .coming-soon {
  background: white;
  align-items: center;
}
.lightTheme .dbtez {
  /* width: 11.5rem; */
  width: 8.5rem;
  transition: width 0.4s ease;
}
.lightTheme .icon {
  width: 40px;
  font-size: 1.3rem;
  transition: width 0.4s ease;
}
.lightTheme .icon-collapse {
  font-size: 1.1rem;
  width: auto;
  transition: width 0.4s ease;
}
.lightTheme .navoptionsallcollapse::-webkit-scrollbar-track {
  background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B); /* Change this to match your sidebar's background color */
  padding-left: 10px;
}
.lightTheme .navoptionsallcollapse::-webkit-scrollbar-thumb {
  background-color: #666; /* Change this to match the color you want for the scrollbar thumb */
  border-radius: 10px; /* Adjust border radius as needed */
}
.lightTheme .navoptionsallcollapse::-webkit-scrollbar-thumb:hover {
  background-color: #999; /* Change this to a lighter shade for hover effect */
}
.lightTheme .navoptionsall::-webkit-scrollbar-track {
  background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B); /* Change this to match your sidebar's background color */
  padding-left: 10px;
}
.lightTheme .navoptionsall::-webkit-scrollbar-thumb {
  background-color: #666; /* Change this to match the color you want for the scrollbar thumb */
  border-radius: 10px; /* Adjust border radius as needed */
}
.lightTheme .navoptionsall::-webkit-scrollbar-thumb:hover {
  background-color: #999; /* Change this to a lighter shade for hover effect */
}
.lightTheme .navoptionsall {
  height: 80vh;
  width: auto;
  transition: width 0.4s ease;
  margin-right: 5px;
  margin-top: 33px;
}
.lightTheme .dbtez {
  /* border-radius: 14px; */
  border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-300, #858686);
  background: rgba(255, 255, 255, 0.2);
  align-items: center;
}
.lightTheme .row-label {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Default/Bold */
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.lightTheme .fEnJOm {
  min-height: 0 !important;
  display: flex;
  /* padding: 8px 16px 8px 64px; */
  align-items: center;
  align-self: stretch;
  margin: 4px;
  margin-top: 12px;
  border-bottom: none !important;
  border-radius: 14px !important;
  padding-top: 2px;
  padding-bottom: 2px;
  background: var(--foundation-neutral-neutral-400, #E3E9F4) !important;
}
.lightTheme .navoptionsallcollapse {
  border-top: none;
  height: 80vh;
  margin-top: 33px;
  width: auto;
  transition: width 0.4s ease;
  margin-right: 5px;
  z-index: 20000000 !important;
}
.lightTheme .navoptionsallcollapse .optionsDropdownCard {
  background: linear-gradient(var(--primary-opactiy-20), var(--primary-opactiy-20)), linear-gradient(var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B), var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B)) top;
  border-radius: 14px;
  transform: translate(60px, -50%);
}
.lightTheme .navoptionsallcollapse .nav-options.activeOption {
  z-index: 9999999 !important;
}
.lightTheme .navoptionsallcollapse:has(.optionsDropdownCard) {
  overflow-y: visible;
  position: relative;
  z-index: -1 !important;
}
.lightTheme .options-dropdown {
  width: 11.5rem;
}
.lightTheme .optionsDropdownCard {
  margin-top: -20px;
  /* position: relative;
  bottom: 0; */
  /* top: 255px; */
  font-size: 18px;
  /* left: 9px; */
  z-index: 999999;
  /* color: white; */
  width: 11.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
  background: var(--primary-opactiy-20);
  border: 1px solid var(--primary-opactiy-20);
  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}
.lightTheme .options-heading-submenu {
  overflow: hidden;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  color: white;
}
.lightTheme .options-heading-submenu:hover {
  color: black;
}
.lightTheme .organisationDropdownCard {
  position: absolute;
  /* bottom:0; */
  /* top: 40px;
  left: 20px; */
  left: 0;
  top: 92%;
  z-index: 200000000 !important;
  width: 11rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  /* popover */
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
}
.lightTheme .organisationDropdownCard > div {
  width: 100%;
}
.lightTheme .select-custom-input {
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 2px solid #E3E9F4;
  border-radius: 12px;
  width: 425px;
  margin-bottom: 15px;
}
.lightTheme .organisations {
  max-height: 40vh;
  overflow: auto;
  border-top: 2px solid #E3E9F4;
  border-bottom: 2px solid #E3E9F4;
}
.lightTheme .organisation-img {
  width: 19px;
  display: block;
  border: 1px solid #E3E9F4;
  padding: 2px;
}
.lightTheme .nav-options-heading {
  overflow: hidden;
  color: white;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.lightTheme .options-heading {
  overflow: hidden;
  color: black;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.lightTheme .roles-heading {
  color: black;
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.lightTheme .options-heading-active {
  overflow: hidden;
  color: black;
  /* text-overflow: unset; */
  margin-left: 23px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.lightTheme .textBlack {
  color: black;
}
.lightTheme .textBlue {
  color: #002d72;
}
.lightTheme .organisation-heading {
  overflow: hidden;
  color: var(--text-high-emphasis, #090826);
  text-overflow: ellipsis;
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  /* line-height: 120%; 16.8px */
}
.lightTheme .oragnisationHover {
  cursor: pointer;
}
.lightTheme .oragnisationHover button {
  font-size: 10px;
  color: rgba(9, 8, 38, 0.3215686275);
  display: block;
}
.lightTheme .oragnisationHover button i {
  display: block;
}
.lightTheme .oragnisationHover:hover {
  border-radius: 14px;
  background: var(--primary);
  color: black !important;
}
.lightTheme .oragnisationHover:focus {
  border-radius: 14px;
  background: var(--primary) 33;
  color: black;
}
.lightTheme #orgHover:hover {
  color: black;
}
.lightTheme .oragnisationHover:active {
  border-radius: 14px;
  background: var(--primary) 33;
}
.lightTheme .oragnisationHover {
  cursor: pointer;
}
.lightTheme .new:hover {
  cursor: pointer;
}
.lightTheme .nav-options {
  position: relative;
  z-index: 20 !important;
}
.lightTheme .tooltip {
  display: flex;
  position: absolute;
  background: #fcfcfe;
  color: var(--text-high-emphasis, #090826);
  gap: 8px;
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  padding: 5px;
  width: max-content;
  border-radius: 4px;
  top: 10px;
  left: 50px;
  z-index: 9000000000000000 !important;
  text-align: justify;
}
.lightTheme .tooltip.tooltip-top {
  left: 50%;
  transform: translateX(-50%);
  top: -18px;
  box-shadow: 3px 4px 16px 0 rgba(0, 11, 65, 0.15);
  padding: 2px 5px;
}
.lightTheme .tooltip.tooltip-top:after {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #ffffff;
  font-size: 0;
  line-height: 0;
  position: absolute;
  bottom: -5px;
  left: calc(50% - 5px);
}
.lightTheme .tooltip.hidden {
  display: none;
}
.lightTheme .plus-icon {
  margin-left: 16px;
}
.lightTheme .status {
  border-radius: 54px;
  border: 2px solid;
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 8px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
  padding: 4px 16px 4px 12px;
}
.lightTheme .status-inprogress {
  border-radius: 54px;
  border: 2px solid rgba(255, 146, 81, 0.5);
  background: rgba(255, 146, 81, 0.2);
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 8px;
  color: var(--foundation-orange-orange-800, #8C502D);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
  padding: 4px 16px 4px 12px;
}
.lightTheme .status-done {
  border-radius: 54px;
  border: 2px solid rgba(106, 218, 0, 0.5);
  background: rgba(106, 218, 0, 0.2);
  align-items: center;
  display: flex;
  justify-content: center;
  color: var(--foundation-green-green-800, #3A7800);
  padding: 4px 16px 4px 12px;
  gap: 8px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .status-backlog {
  padding: 4px 16px 4px 12px;
  border-radius: 54px;
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: var(--foundation-neutral-neutral-200, #EFF3F9);
  align-items: center;
  display: flex;
  justify-content: center;
  color: var(--foundation-neutral-neutral-900, #5C6065);
  gap: 8px;
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .dueto-today {
  display: flex;
  height: 32px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  gap: 4px;
  color: var(--text-white-high-emphasis, #FCFCFE);
  border-radius: 20px;
  background: var(--foundation-orange-orange-500, #FF9251);
  /* Typography/Body/Small/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 14.4px */
}
.lightTheme .dueto-past {
  border-radius: 20px;
  background: var(--foundation-red-red-500, #FF6969);
  display: flex;
  height: 32px;
  padding: 0px 8px 0px 12px;
  align-items: center;
  gap: 4px;
  color: var(--text-white-high-emphasis, #FCFCFE);
  /* Typography/Body/Small/Bold */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 14.4px */
}
.lightTheme .duto-text {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .progressbar {
  color: #E3E9F4;
  background-color: #E3E9F4;
  border-radius: 14px;
}
.lightTheme .task {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Heading 5/Bold */
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 28.8px */
}
.lightTheme .members {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Large/Regular */
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
  border-bottom: 1px solid #E3E9F4;
}
.lightTheme .member-dropdown {
  height: 200px;
}
.lightTheme .memberscard {
  position: absolute;
  /* bottom: 0; */
  top: 32px;
  left: -115px;
  right: 0;
  z-index: 1000;
  width: 300px;
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}
.lightTheme .generate-password {
  min-width: 252px;
  min-height: 22px !important;
  flex: 1 1;
  padding: 7px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-right: 12px;
}
.lightTheme .rdt_TableRow {
  min-height: auto !important;
}
.lightTheme .rdt_TableCell {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.lightTheme .rdt_TableHeadRow {
  background: #E3E9F4 !important;
  border-radius: 12px;
  min-height: 38px !important;
}
.lightTheme .rdt_TableBody {
  overflow: scroll;
  height: calc(100vh - 305px);
  padding-bottom: 60px;
  padding-right: 8px;
}
.lightTheme .toggle-password {
  position: absolute;
  right: 20px;
  top: 13px;
  cursor: pointer;
}
.lightTheme .email-field {
  height: 22px;
}
.lightTheme input[type=checkbox] {
  width: 18px !important;
  height: 18px !important;
  margin-right: 10px;
  margin-top: 5px;
  -o-appearance: none;
  appearance: none;
  box-shadow: none;
  font-size: 0.8em;
  text-align: center;
  line-height: 1.2em;
  background: var(--foundation-neutral-neutral-100, #F4F7FB);
  border: 2px solid black;
}
.lightTheme input[type=checkbox]:checked:after {
  height: 20px !important;
  content: "🗸";
  padding: 2px;
  font-weight: 600;
  font-size: 1rem;
  color: white;
  background: var(--primary);
  border: 2px solid var(--secondary-700);
  border-radius: 1px;
}
.lightTheme .edit-user {
  background: white;
  height: -moz-fit-content;
  height: fit-content;
  width: 595px;
}
.lightTheme .edit-category {
  background: white;
  height: -moz-fit-content;
  height: fit-content;
  width: 595px;
}
.lightTheme .input-field {
  width: 245px;
}
.lightTheme .toggle-bg {
  position: relative;
  display: inline-block;
  width: 180px;
  height: 31px;
}
.lightTheme .toggle-slider {
  position: absolute;
  content: "";
  height: 31px;
  width: 95px;
  left: -17px;
  top: 0px;
  background-color: #9CA2AB;
  transition: 0.4s;
}
.lightTheme input[type=checkbox]:checked + label:before {
  background-color: var(--primary) !important;
}
.lightTheme .teamInfoPopup {
  background: white;
  height: -moz-fit-content;
  height: fit-content;
  width: 1050px;
}
.lightTheme .teamInfoGrid {
  gap: 34rem;
}
.lightTheme .vl {
  border-left: 1px solid #ccc;
  margin-top: -94px;
}
.lightTheme .small-text {
  font-size: 8px;
}
.lightTheme .badge-text {
  font-size: 11px;
}
.lightTheme .team-name {
  min-width: 630px;
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.lightTheme .teamInfoSidebar {
  margin-left: 50px;
}
.lightTheme .info-badge {
  background-color: #EFF3F9;
  padding: 5px;
  width: 185px;
  border-radius: 15px;
}
.lightTheme .badge-icon {
  margin: 12px;
}
.lightTheme .popup-text {
  font-weight: 500;
  font-size: 13px;
}
.lightTheme .date-text {
  font-size: 11px;
}
.lightTheme .profile-cover {
  width: 145px;
  height: 145px;
  margin: 15px;
}
.lightTheme .img-div {
  border-left: 1px solid #ccc;
}
.lightTheme .team-mate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 9px 14px;
  min-width: 470px;
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-right: 12px;
  padding-left: 29px;
}
.lightTheme .team-mate::placeholder {
  color: rgba(9, 8, 38, 0.3215686275);
  font-size: 13px;
}
.lightTheme .switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 12px;
}
.lightTheme .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.lightTheme .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E3E9F4;
  transition: 0.4s;
}
.lightTheme .slider:before {
  position: absolute;
  content: "";
  height: 31px;
  width: 95px;
  left: 0px;
  top: 0px;
  background-color: #88E133;
  transition: 0.4s;
}
.lightTheme .toggle-btn-text {
  position: absolute;
  top: 6px;
  margin-left: 17px;
  font-weight: 500;
}
.lightTheme .toggle-btn-dis-text {
  position: absolute;
  top: 6px;
  margin-left: 104px;
  font-weight: 500;
}
.lightTheme input:checked + .slider {
  background-color: rgba(92, 96, 101, 0.0588235294);
}
.lightTheme input:focus + .slider {
  box-shadow: 0 0 1px var(--secondary-200);
}
.lightTheme input:checked + .slider:before {
  transform: translateX(85px);
  background-color: #FF8787;
}
.lightTheme .slider.round {
  border-radius: 34px;
}
.lightTheme .slider.round:before {
  border-radius: 15px;
}
.lightTheme .toggle-text {
  margin-top: -4px;
  margin-left: 10px;
  font-size: 13px;
  font-weight: 600;
}
.lightTheme .toggle-checkbox {
  display: none;
  visibility: hidden !important;
}
.lightTheme .toggle-btn-dis-text {
  position: absolute;
  top: 6px;
  margin-left: 104px;
  font-weight: 600;
}
.lightTheme .team-mates-scroll {
  overflow-y: scroll;
  height: 470px;
}
.lightTheme .team-leads-scroll {
  overflow-y: scroll;
  height: 330px;
}
.lightTheme ::-webkit-scrollbar {
  width: 6px;
  margin-left: 4px;
}
.lightTheme ::-webkit-scrollbar-track {
  background: #fff;
}
.lightTheme ::-webkit-scrollbar-thumb {
  background: #E3E9F4;
  border-radius: 20px;
}
.lightTheme ::-webkit-scrollbar-thumb:hover {
  background: #E3E9F4;
}
.lightTheme .permissions-tab {
  min-width: 615px;
  overflow: scroll;
}
.lightTheme .permission-badge {
  background-color: #EFF3F9;
  padding: 8px;
  width: 315px;
  border-radius: 15px;
  height: 37px;
}
.lightTheme .permission-text {
  font-size: 11px;
  font-weight: 500;
}
.lightTheme .team-label-img {
  height: 40px;
  min-width: 40px;
}
.lightTheme .team-label-heading {
  color: var(--text-high-emphasis, #090826);
  font-family: Inter;
  text-align: left;
  font-size: 0.6rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
}
.lightTheme .project-info {
  margin-left: 360px;
}
.lightTheme .permission-info {
  width: 80px;
  background-color: #F0FBE6;
  padding: 8px;
  border-radius: 15px;
  height: 37px;
}
.lightTheme .permission-rejected {
  width: 80px;
  background-color: #FFF0F0;
  padding: 8px;
  border-radius: 15px;
  height: 37px;
}
.lightTheme .permission-table {
  height: 15px;
  min-width: 16px;
  margin-left: 22px;
  margin-top: 2px;
}
.lightTheme .permission-warning {
  height: 10px;
  min-width: 12px;
  margin-top: -3px;
  margin-left: 15px;
}
.lightTheme .permission-approval {
  position: absolute;
  z-index: 1000;
  width: 275px;
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: #FFF;
}
.lightTheme .team-mate-accordion {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 12px 14px;
  min-width: 394px;
  flex: 1 1;
  padding: 9px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-right: 12px;
  padding-left: 36px;
}
.lightTheme .members-count {
  font-size: 11px;
  font-weight: 500;
  margin: 2px;
  margin-right: 9px;
}
.lightTheme .accordion-btn {
  padding: 14px 20px;
  background-color: white;
  color: black;
  border-bottom: 2px solid #E3E9F4;
  cursor: pointer;
  margin-right: 10px;
  width: 599px;
  text-align: left;
  justify-content: space-between;
}
.lightTheme .accordion-label {
  font-weight: 700;
  font-size: 13px;
  margin: 7px;
}
.lightTheme .accordion-content {
  font-size: 20px;
  margin-top: 20px;
}
.lightTheme .accordion-btn:hover {
  background-color: #EFF3F9;
  border-bottom: 2px solid #E3E9F4;
}
.lightTheme .accordion-btn:active {
  border: none;
}
.lightTheme .accordion-btn:focus {
  border: none;
}
.lightTheme .notification {
  z-index: 9999999999;
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
  width: 400px;
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: white;
  color: black;
  padding: 0px 0px;
  border-radius: 14px;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.lightTheme .notification-message {
  color: #090826;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 5px;
  padding: 5px;
  border-radius: 5px;
}
.lightTheme .msg-container {
  padding: 20px 20px;
}
.lightTheme .notification-icon {
  display: flex;
  border-bottom-left-radius: 14px;
  border-top-left-radius: 14px;
  width: 95px;
  align-items: center;
  justify-content: center;
}
.lightTheme .notification.show {
  transform: translateX(0);
  opacity: 1;
}
.lightTheme .overlay {
  position: fixed;
  top: 0;
  z-index: 20000000000 !important;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--foundation-neutral-neutral-900, rgba(92, 96, 101, 0.7568627451));
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lightTheme .overlay .taskPopUp, .lightTheme .overlay .memberPopup, .lightTheme .overlay .modalPopup {
  background: white;
  /* height: 48vh !important; */
  overflow-x: hidden;
  max-height: 95vh;
  min-width: auto;
}
.lightTheme .overlay .taskPopUp.h-auto, .lightTheme .overlay .memberPopup.h-auto, .lightTheme .overlay .modalPopup.h-auto {
  height: auto !important;
  min-height: auto;
}
.lightTheme .overlay .taskPopUp .scrollable, .lightTheme .overlay .memberPopup .scrollable, .lightTheme .overlay .modalPopup .scrollable {
  max-height: 65vh;
  overflow-y: auto;
  scroll-behavior: smooth;
  height: -webkit-fill-available;
}
.lightTheme .overlay .taskPopUp .title, .lightTheme .overlay .memberPopup .title, .lightTheme .overlay .modalPopup .title {
  overflow: hidden;
  color: var(--text-high-emphasis, #090826);
  text-overflow: ellipsis;
  /* Typography/Heading 3/Bold */
  font-family: Inter;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 42px */
}
.lightTheme .overlay .taskPopUp .title-text-small-color, .lightTheme .overlay .memberPopup .title-text-small-color, .lightTheme .overlay .modalPopup .title-text-small-color {
  color: var(--text-high-emphasis, #090826);
}
.lightTheme .overlay .border-right {
  border-right: 1px solid #E3E9F4;
}
.lightTheme .overlay .play-pause {
  background: var(--foundation-secondary-secondary-50, var(--secondary-200));
}
.lightTheme .overlay .play-pause.on {
  background: var(--foundation-secondary-secondary-500, var(--secondary-700));
}
.lightTheme .overlay .play-pause.on .play-pause-button {
  background: var(--foundation-secondary-secondary-50, var(--secondary-200));
}
.lightTheme .overlay .play-pause.on .play-pause-button i {
  color: #000000;
}
.lightTheme .overlay .play-pause-button {
  border-radius: 50px;
  background: var(--foundation-secondary-secondary-500, var(--secondary-700));
  box-shadow: 0px 4px 8px 0px rgba(92, 96, 101, 0.06);
}
.lightTheme .overlay .sum-title {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Large/Bold */
  font-family: Inter;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 19.2px */
}
.lightTheme .overlay .uploadedFile {
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: var(--foundation-neutral-neutral-50, #FCFCFE);
  position: relative;
  /* org */
  /* card */
  box-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);
}
.lightTheme .overlay .uploadedFile .orgCreate {
  border-radius: 24px;
  background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);
  /* modal page */
  box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.4);
  min-height: 80vh;
  min-width: auto;
  height: 50vh !important;
  overflow-x: hidden;
}
.lightTheme .overlay .uploadedFile .filename {
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Default/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
}
.lightTheme .overlay .uploadedFile .fileDetail {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  /* Typography/Body/Extra Small/Regular */
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 12px */
}
.lightTheme .overlay .uploadedFile .document-svg {
  box-shadow: 2px 4px 10px 0px rgba(92, 96, 101, 0.24);
}
.lightTheme .overlay .uploadedFile .pdf {
  border-radius: 1px;
  background: var(--foundation-red-red-500, #FF6969);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.lightTheme .overlay .uploadedFile .default {
  border-radius: 1px;
  background: var(--foundation-red-red-500, #48792f);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.lightTheme .overlay .uploadedFile .png {
  border-radius: 1px;
  background: var(--foundation-dark-blue-dark-blue-500, #6C9BF6);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.lightTheme .overlay .uploadedFile .svg {
  border-radius: 1px;
  background: var(--foundation-red-red-500, #f09409);
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.lightTheme .alert {
  height: auto;
  align-items: flex-end;
  left: -175px;
}
.lightTheme .popup {
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background: var(--foundation-neutral-neutral-50, #FCFCFE);
  /* card */
  box-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);
}
.lightTheme .popup .description-txt {
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .popup .link-txt {
  border-radius: 14px;
  border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .popup .icon-color {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
}
.lightTheme .popup .input-custom {
  border-radius: 14px;
  color: black;
}
.lightTheme .btn-popup {
  border: 2px solid var(--primary);
  background: var(--foundation-secondary-secondary-400, var(--primary));
  box-shadow: 0px 10px 10px 0px var(--primary-opactiy-40);
  font-weight: 600;
}
.lightTheme .btn-popup:hover {
  background: var(--secondary-300);
  border: 2px solid var(--secondary-300);
}
.lightTheme .border-btn-select {
  border: 2px solid rgba(9, 8, 38, 0.6);
}
.lightTheme .bg-btn-teal {
  background: var(--foundation-secondary-secondary-500, var(--secondary-700));
}
.lightTheme .sidebar-data-todo {
  border-radius: 14px;
  background: var(--foundation-neutral-neutral-100, #F4F7FB);
}
.lightTheme .sidebar-txt {
  margin-top: 5px;
  color: var(--text-high-emphasis, #090826);
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.lightTheme .task-tab {
  border-radius: 14px;
  background: var(--foundation-secondary-secondary-50, var(--secondary-200));
  color: var(--foundation-secondary-secondary-800, var(--secondary-500));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .comment-box {
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .todo-hover:hover {
  border-radius: 14px;
  background: var(--foundation-neutral-neutral-400, #E3E9F4);
}
.lightTheme .dropdown-task {
  border-radius: 14px;
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background-color: transparent;
  color: var(--text-high-emphasis, #090826);
  /* Typography/Body/Default/Regular */
  font-family: Inter;
}
.lightTheme .progress-estimated {
  font-size: 10px;
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
}
.lightTheme .active-status {
  border-radius: 54px;
  border: 2px solid rgba(106, 218, 0, 0.5);
  background: rgba(106, 218, 0, 0.2);
  color: var(--foundation-green-green-800, #3A7800);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .unactive-status {
  border-radius: 54px;
  border: 2px solid rgba(255, 105, 105, 0.5);
  background: rgba(255, 105, 105, 0.2);
  color: var(--foundation-red-red-800, #8C3A3A);
  /* Typography/Body/Small/Regular */
  font-family: Inter;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 14.4px */
}
.lightTheme .rdt_TableRow {
  border-bottom: none !important;
}
.lightTheme .shift-table .rdt_TableRow {
  border-bottom: 2px solid var(--neutral-400) !important;
}
.lightTheme .dropdown-custom {
  background-color: white;
  border: 1px solid var(--main-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  /* popover */
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
  z-index: 100000 !important;
  display: block;
}
.lightTheme .member-section-title {
  color: var(--main-secondary-secondary-800, var(--secondary-500));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .dropdown-container {
  border: 2px solid #E3E9F4 !important;
  box-shadow: none !important;
  border-radius: 14px !important;
}
.lightTheme .dropdown-container:focus-within {
  border: 2px solid #E3E9F4 !important;
  box-shadow: none !important;
}
.lightTheme .rmsc .gray {
  color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32)) !important;
}
.lightTheme select, .lightTheme option {
  background-color: white !important;
}
.lightTheme .dropdown-menu {
  position: absolute;
  /* top: 8px; */
  z-index: 100000000000000 !important;
  border-radius: 14px;
  border: 1px solid var(--main-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}
.lightTheme .dropdown, .lightTheme .btn-simple {
  border: 2px solid var(--main-neutral-neutral-400, #E3E9F4);
}
.lightTheme .invite-link {
  color: var(--main-secondary-secondary-800, var(--secondary-500));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
}
.lightTheme .btn-green {
  background: var(--main-secondary-secondary-400, var(--primary));
  box-shadow: 0px 10px 31px 0px var(--primary-opactiy-40);
}
.lightTheme .navtab-active {
  border-radius: 14px;
  background: var(--main-secondary-secondary-50, var(--secondary-200));
  color: var(--main-secondary-secondary-800, var(--secondary-500));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
}
.lightTheme .navtab-unactive {
  color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));
  /* Typography/Body/Default/Bold */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
}
.lightTheme .txt-green {
  color: var(--main-secondary-secondary-800, var(--secondary-500));
}
.lightTheme .online {
  background-color: var(--main-green-green-500, #6ADA00);
}
.lightTheme .multi-dropdown {
  border-radius: 14px;
  border: 1px solid var(--main-neutral-neutral-400, #E3E9F4);
  background: #FFF;
  box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.2);
}
.lightTheme .btn-red {
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: var(--main-red-red-500, #FF6969);
  box-shadow: 0px 10px 31px 0px rgba(255, 105, 105, 0.4);
}
.lightTheme .form-steps-active {
  background-color: #C8CFDB;
  height: 40px;
  width: 40px;
  box-shadow: 0 0 0 3px #fff inset;
  box-sizing: border-box;
  border: 2.5px solid #C8CFDB;
}
.lightTheme .form-steps-complete {
  background-color: var(--primary);
  height: 40px;
  width: 40px;
  box-shadow: 0 0 0 3px #fff inset;
  box-sizing: border-box;
}
.lightTheme .divider {
  background: var(--primary);
}
.lightTheme .form-steps {
  background-color: #C8CFDB;
  height: 40px;
  width: 40px;
  box-shadow: 0 0 0 3px #fff inset;
  box-sizing: border-box;
}
.lightTheme .check-icon {
  height: 11px;
}
.lightTheme .multiselect-wrapper {
  position: relative;
}
.lightTheme .pill-container {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 30px);
  padding: 3px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.lightTheme .pill {
  background-color: #e0e0e0;
  padding: 5px 10px;
  margin: 5px;
  border-radius: 20px;
}
.lightTheme .custom-input {
  flex: 1 1;
  padding: 10px;
  box-sizing: border-box;
  border: 2px solid #E3E9F4;
  border-radius: 12px;
}
.lightTheme .custom-input:disabled {
  background-color: rgba(221, 221, 221, 0.7) !important;
  opacity: 1;
}
.lightTheme .custom-logo-upload:hover {
  background-color: #ededed;
}
.lightTheme .rmsc .dropdown-container {
  width: 215px;
  height: 39px;
  box-sizing: border-box;
  border: 2px solid #E3E9F4 !important;
  border-radius: 12px !important;
  font-weight: 500;
}
.lightTheme .error-text {
  font-size: 12px;
  color: var(--red-300);
  width: 0px !important;
}
.lightTheme .cancel-btn-popup {
  border: 2px solid #E3E9F4;
  background: var(--foundation-secondary-secondary-400, #fff);
  border-radius: 11px;
  margin-right: 5px;
  font-weight: 600;
}
.lightTheme .cancel-btn-popup:hover {
  background: #ededed;
}
.lightTheme .permission-page {
  overflow: scroll;
  height: 43vh;
}
.lightTheme .value-text {
  color: var(--text-high-emphasis, #090826);
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: 60%;
}
.lightTheme .info-box {
  padding-left: 15px;
  padding-right: 15px;
  border-left: 3px solid #DCE4F1;
}
.lightTheme .role-info {
  width: 420px;
}
.lightTheme input[type=file] {
  display: none;
}
.lightTheme .custom-file-upload {
  border: 2px solid #E3E9F4;
  display: inline-block;
  padding: 8px 18px;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 600;
}
.lightTheme .spacing-div {
  margin-left: 12rem;
}
.lightTheme .modalPopup .spacing-div {
  margin-left: auto;
}
.lightTheme .spacing-div-sm {
  margin-left: 18rem;
}
.lightTheme select:invalid {
  color: rgba(0, 0, 0, 0.35);
}
.lightTheme .info-icon, .lightTheme .info-icon:hover, .lightTheme .info-icon:focus {
  font-weight: normal;
  border: 1px solid var(--primary);
  font-style: italic;
  color: #000000;
  display: inline-block;
  font-size: 10px;
  width: 15px;
  height: 15px;
  line-height: 13px;
  text-align: center;
  border-radius: 50%;
  background-color: transparent;
  padding: 0;
  vertical-align: middle;
}
.lightTheme .custom-logo-upload {
  border: 2px solid #E3E9F4;
  display: inline-block;
  padding: 8px 28px;
  cursor: pointer;
  border-radius: 10px;
  font-weight: 600;
  width: 150px;
  margin-top: 5px;
}
.lightTheme .red-btn {
  border-radius: 9px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  background: #FF6969;
  color: var(--text-high-emphasis, #090826);
  font-family: Inter;
  font-size: 0.82rem;
  font-style: normal;
  font-weight: 600;
  line-height: 143%;
}
.lightTheme .red-btn:hover {
  background: #ff9c9c;
  border: 2px solid #ff9c9c;
}
.lightTheme .edit-user-profile {
  font-size: 27px;
  font-weight: 400;
}
.lightTheme .btn-create {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 100%;
}
.lightTheme .btn-more-options i, .lightTheme .btn-create i {
  color: rgba(9, 8, 38, 0.6);
}
.lightTheme div:has(> .more-options-wrapper) {
  overflow: unset !important;
}
.lightTheme .more-options-wrapper {
  position: relative;
  overflow: unset !important;
}
.lightTheme .more-options-wrapper .btn-more-options {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 100%;
}
.lightTheme .more-options-wrapper .btn-more-options:hover, .lightTheme .btn-create:hover {
  background-color: var(--primary-opactiy-10);
}
.lightTheme .more-options-wrapper .more-options {
  position: absolute;
  right: 0;
  top: 22px;
  background-color: #ffffff;
  border: 1px solid #E3E9F4;
  z-index: 9;
  padding: 13px 15px;
  text-align: center;
  border-radius: 14px;
  box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);
}
.lightTheme .items-row:last-of-type .more-options-wrapper .more-options {
  bottom: 22px;
  top: auto;
}
.lightTheme .more-options-wrapper .more-options > button {
  display: flex;
  align-items: center;
}
.lightTheme .more-options-wrapper .more-options > button:disabled {
  color: #bbbbbb;
}
.lightTheme .more-options-wrapper .more-options > button:not(:last-child) {
  margin-bottom: 15px;
}
.lightTheme .more-options-wrapper .more-options > button span {
  min-width: max-content;
  margin-left: 10px;
  padding: 4px 25px;
}
.lightTheme .more-options-wrapper .more-options > button span:hover {
  background-color: var(--foundation-neutral-neutral-400, #E3E9F4);
  padding: 4px 25px;
  border-radius: 13px;
}

.tooltip.show {
  left: 50%;
  transform: translateX(-50%);
  top: -18px;
  box-shadow: -3px 4px 16px 0 rgba(0, 11, 65, 0.15);
  padding: 2px 5px;
  border-radius: 5px;
  background-color: #ffffff;
  position: relative;
  z-index: 9999999999;
}

.tooltip.show:after {
  content: "";
  width: 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  position: absolute;
}

.tooltip.show.bs-tooltip-end:after {
  border-bottom: 5px solid transparent;
  border-right: 5px solid #ffffff;
  border-top: 5px solid transparent;
  bottom: 8px;
  left: -5px;
}

.checkbox-toggle-simple {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 16px;
  background-color: #dddddd;
  border-radius: 40px;
  cursor: pointer;
}

.checkbox-toggle-simple:has(input:checked) {
  background-color: var(--secondary-200);
}

.checkbox-toggle-simple input {
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox-toggle-simple input + span {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #bababa;
  top: -2px;
  left: 0;
  transition: 0.4s;
}

.checkbox-toggle-simple input:checked + span {
  background-color: var(--secondary-700);
  transform: translateX(20px);
  transition: 0.4s;
}

.title-bdr-btm {
  border-bottom: 2px solid #E3E9F4;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.assignee-list > div {
  border: 1px solid #ffffff;
  border-radius: 50%;
}

.assignee-list > div:not(:first-child) {
  margin-left: -0.6em;
}

button.btn-remove {
  position: absolute;
  top: -10px;
  right: -5px;
  border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);
  background-color: var(--foundation-neutral-neutral-50, #FCFCFE);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  line-height: 12px;
}
button.btn-remove > i {
  font-size: 0.7em;
  line-height: 12px;
}

.rdt_TableHeader {
  flex: none !important;
}

input[type=date] {
  position: relative;
}

input[type=date]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}

input[type=date]:before {
  position: absolute;
  font-family: "Font Awesome 5 Free";
  content: "\\f133";
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  font-weight: 900;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.Navheader-collapse > div {
  background-color: --foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B;
}

.org-selector.pb-3:after {
  content: "";
  display: block;
  width: calc(100% - 30px);
  height: 15px;
  margin: 0 15px;
  border-bottom: 2px solid rgba(109, 111, 111, 0.6352941176);
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EA8xBI,8BAAA;EAMA,iCAAA;EASA,8BAAA;EAMA,iCAAA;EAouBF,oBAAA;EAsCD,UAAA;EAMC,UAAA;EAKA,WAAA;EAMA,oBAAA;EAqxBD,yBAAA;AAv1ED;AAXI;EACI,sBAAA;AAaR;AAXI;EACI,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACF,UAAA;EACA,0DAAA;EACD,iBAAA;EACA,gCAAA;AAaL;AAXI;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;AAaR;AAVI;EACI,mBAAA;EACR,gEAAA;EACA,gBAAA;EACA,UAAA;EAEA,YAAA;EACA,qDAAA;AAWA;AARI;EACI,yCAAA;AAUR;AALI;EAGI,gBAAA;EACA,gBAAA;AAKR;AAFI;EACA;IACA,gBAAA;IACA,gBAAA;EAIF;EADE;IACI,gBAAA;IACA,YAAA;EAGN;AACF;AAAI;EACI,iBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iCAAA;AACR;AAEI;EACI,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAAR;AAGI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAII;EACI,+CAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAFR;AAKI;EACI,mBAAA;EACA,0BAAA;EACA,YAAA;EACA,2CAAA;EACA,iBAAA;EACA,+pCAAA;EACA,4BAAA;EACA,yBAAA;AAHR;AAMI;EACI,+CAAA;EAEA,mBAAA;EACJ,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AALJ;AASI;EACI,YAAA;EACA,0BAAA;EACA,mBAAA;EACJ,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,cAAA;AAPJ;AAUI;EACI,0BAAA;EACA,cAAA;EACA,gBAAA;AARR;AAUI;EACI,0BAAA;EACA,cAAA;EACA,gBAAA;AARR;AAUI;EACI,0BAAA;EACA,cAAA;EACA,gBAAA;AARR;AAUI;EACI,0DAAA;AARR;AAcI;EACI,+CAAA;EACA,aAAA;EACA,8BAAA;EAEA,mBAAA;EACJ,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAbJ;AAeI;EACI,0BAAA;EACA,YAAA;EACA,gBAAA;AAbR;AAiBI;EACI,YAAA;EAEA,kBAAA;EACC,mHAAA;AAhBT;AAmBK;EAEI,YAAA;EACA,iBAAA;EACA,mHAAA;AAlBT;AAoBK;EACI,+CAAA;EAEA,8BAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AApBT;AAsBK;EACG,iBAAA;EACA,YAAA;EAEA,mBAAA;AArBR;AAwBK;EAEA,0CAAA;EACA,qEAAA;EACA,uDAAA;EACA,cAAA;EAEA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAxBL;AA4BI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AA1BR;AA4BQ;EACI,iBAAA;EACJ,gCAAA;EAEI,aAAA;EACJ,mBAAA;EACA,yBAAA;AA3BR;AA6BQ;EACI,cAAA;AA3BZ;AA6BQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA3BZ;AA6BQ;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA3BZ;AA6BQ;EACA,gEAAA;AA3BR;AA6BQ;EACI,uDAAA;EACA,eAAA;AA3BZ;AA6BQ;EACI,yCAAA;EAEJ,8BAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA7BR;AA+BQ;EACI,uDAAA;EAEJ,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9BR;AAgCQ;EACA,gEAAA;AA9BR;AAgCQ;EACI,mBAAA;EACA,gCAAA;EACA,qEAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA9BZ;AAiCQ;EACI,sDAAA;EACA,sDAAA;EACA,gBAAA;AA/BZ;AAiCQ;EACI,gCAAA;AA/BZ;AAkCQ;EACI,kBAAA;EACA,cAAA;EACA,SAAA;EACD,QAAA;EACC,aAAA;EACA,YAAA;EAEA,mBAAA;EACJ,gEAAA;EACA,gBAAA;EAEA,YAAA;EACA,qDAAA;AAlCR;AAqCQ;EACI,0DAAA;AAnCZ;AAqCQ;EACI,yCAAA;EAEJ,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AApCR;AAsCQ;EACI,6BAAA;AApCZ;AAuCQ;EACI,mBAAA;EACA,0DAAA;AArCZ;AAuCQ;EACI,gEAAA;EACA,YAAA;EACJ,eAAA;AArCR;AAuCQ;EACI,yCAAA;EACJ,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AArCR;AAuCQ;EACI,uDAAA;EACJ,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArCR;AAuCQ;EACI,aAAA;AArCZ;AAuCQ;EACI,yCAAA;EAEJ,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAtCR;AAwCQ;EAGA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAxCR;AA0CQ;EACI,6BAAA;EAIA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA3CZ;AA6CQ;EACI,mBAAA;EACA,0DAAA;AA3CZ;AA6CQ;EACI,aAAA;EACA,sBAAA;AA3CZ;AA8CI;EACI,uBAAA;AA5CR;AA8CI;EACI,mBAAA;EACA,gCAAA;EACA,aAAA;EAEA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,qCAAA;EACH,kBAAA;AA7CL;AAiDI;EACM,aAAA;EACA,wBAAA;EACA,mBAAA;EAEA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAjDV;AAoDI;EACI,2BAAA;AAlDR;AAoDI;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,sCAAA;AAlDJ;AAsDI;EAEI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,qCAAA;AArDR;AAwDI;EACI,uDAAA;EACA,sBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAvDR;AA4DM;EAAa,aAAA;EACX,wBAAA;AAzDR;AA0DQ;EAEI,iCAAA,EAKA,WAAA;EACA,iBAAA;EAGA,qDAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA1DZ;AA4DU;EACC,mBAAA;EACA,mBAAA;EACA,0DAAA;EACC,iBAAA;AA1DZ;AA6DU;EACE,qDAAA;AA3DZ;AA+DU;EACE,yCAAA;EAEA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9DZ;AAgEU;EACE,0BAAA;EACA,qBAAA;AA9DZ;AAgEU;EACE,uDAAA;AA9DZ;AAgEU;EACE,2BAAA;AA9DZ;AAiEI;EACI,yCAAA;EACJ,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;AA/DJ;AAkEI;EACI,eAAA;EACJ,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhEJ;AAkEI;EACE,yCAAA;EACF,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAhEJ;AAkEI;EACE,eAAA;EACA,aAAA;EACF,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,mDAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAhEJ;AAkEI;EACI,aAAA;EACF,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,sCAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAhEN;AAkEI;EACE,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EAEA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAjEJ;AAmEI;EACI,eAAA;EACF,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,wCAAA;EACA,kCAAA;EACA,iDAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAlEJ;AAoEI;EACE,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kDAAA;EACA,mCAAA;EACA,cAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAnEJ;AAsEI;EACI,aAAA;EACF,0BAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;EACA,cAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArEN;AAwEI;EAEA,kBAAA,EAIA,WAAA;EACA,qDAAA;EAEA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAxEJ;AA0EI;EACE,yCAAA;EACA,YAAA;EAEF,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAzEJ;AA2EI;EACE,uDAAA;EACF,kBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA1EJ;AA4EI;EACE,qDAAA;EAEF,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA3EJ;AA6EI;EACE,qDAAA;EACF,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA3EJ;AA6EI;EAEA,4BAAA;EACA,0BAAA;AA5EJ;AA8EI;EACE,0BAAA;AA5EN;AA8EI;EACE,oCAAA;EACA,8BAAA;AA5EN;AA+EI;EACI,cAAA;EACA,2BAAA;EAEA,mBAAA;EACF,eAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AA9EN;AAgFI;EACI,WAAA;EACA,2BAAA;EACA,mBAAA;EACF,eAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;AA9EN;AAqFI;EACI,YAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;AAnFR;AAsFI;EACI,eAAA;EACA,aAAA;AApFR;AAsFI;EACI,iBAAA;EACA,mBAAA;AApFR;AAsFI;EACI,oBAAA;EACA,aAAA;EACJ,2BAAA;AApFJ;AAsFI;EACI,WAAA;EACA,iBAAA;EACA,2BAAA;AApFR;AAsFI;EACI,iBAAA;EACA,WAAA;EACA,2BAAA;AApFR;AAsFI;EACI,sFAAA,EAAA,yDAAA;EACA,kBAAA;AApFR;AAwFI;EACI,sBAAA,EAAA,oEAAA;EACA,mBAAA,EAAA,mCAAA;AAtFR;AA0FI;EACI,sBAAA,EAAA,oDAAA;AAxFR;AA0FI;EACI,sFAAA,EAAA,yDAAA;EACA,kBAAA;AAxFR;AA4FI;EACI,sBAAA,EAAA,oEAAA;EACA,mBAAA,EAAA,mCAAA;AA1FR;AA8FI;EACI,sBAAA,EAAA,oDAAA;AA5FR;AA+FI;EACI,YAAA;EAEA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;AA9FR;AAsGI;EACI,yBAAA;EACJ,sFAAA;EACA,oCAAA;EACA,mBAAA;AApGJ;AAsGI;EACI,yCAAA;EAEJ,iCAAA;EAEA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAtGJ;AAwGI;EACI,wBAAA;EACA,aAAA;EACJ,gCAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EAEA,8BAAA;EACI,8BAAA;EACA,gBAAA;EACA,mBAAA;EACJ,qEAAA;AAvGJ;AAyGI;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EAEA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,4BAAA;AAxGR;AA0GQ;EACI,kPACI;EAEJ,mBAAA;EACA,gCAAA;AA1GZ;AA6GQ;EAA2B,2BAAA;AA1GnC;AA2GQ;EAA4B,mBAAA;EAAqB,kBAAA;EAAoB,sBAAA;AAtG7E;AAwGI;EACI,cAAA;AAtGR;AAwGI;EACI,iBAAA;EACA;cAAA;EAEA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,gCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wDAAA;AAtGR;AAyGI;EACI,gBAAA;EAEA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAxGR;AA0GI;EAEI,YAAA;AAzGR;AA2GI;EACI,kBAAA;EACA,cAAA;EACA;eAAA;EAEA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACD,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACC,mBAAA;EACJ,gEAAA;EACA,gBAAA;EAEA,YAAA;EACA,qDAAA;AA1GJ;AA2GI;EAAM,WAAA;AAxGV;AA2GI;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAzGR;AA2GI;EACI,gBAAA;EACJ,cAAA;EACA,6BAAA;EACA,gCAAA;AAzGJ;AA4GI;EACI,WAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AA1GR;AA6GI;EAEI,gBAAA;EACJ,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA5GJ;AAgHI;EAEI,gBAAA;EACJ,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA/GJ;AAmHI;EACI,YAAA;EACJ,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAjHJ;AAoHI;EAEI,gBAAA;EACJ,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAnHJ;AAsHI;EACI,YAAA;AApHR;AAsHI;EACI,cAAA;AApHR;AAsHI;EACI,gBAAA;EACJ,yCAAA;EACA,uBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AArHJ;AAuHI;EACI,eAAA;AArHR;AAsHQ;EACI,eAAA;EACA,mCAAA;EACA,cAAA;AApHZ;AAqHY;EAAG,cAAA;AAlHf;AAqHI;EACI,mBAAA;EACA,0BAAA;EACA,uBAAA;AAnHR;AAuHI;EACI,mBAAA;EACJ,6BAAA;EACA,YAAA;AArHJ;AAwHI;EACI,YAAA;AAtHR;AAyHI;EACI,mBAAA;EACA,6BAAA;AAvHR;AA2HI;EACI,eAAA;AAzHR;AA2HI;EACI,eAAA;AAzHR;AA2HI;EACI,kBAAA;EACA,sBAAA;AAzHR;AA2HI;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,mBAAA;AAzHR;AA0HQ;EACI,SAAA;EAAW,2BAAA;EAA6B,UAAA;EAAY,gDAAA;EAAkD,gBAAA;AApHlH;AAqHY;EAAQ,WAAA;EAAa,QAAA;EAAU,SAAA;EAAW,kCAAA;EAAoC,mCAAA;EAAqC,6BAAA;EAA+B,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAAoB,YAAA;EAAc,qBAAA;AAxG9N;AA0GQ;EAAU,aAAA;AAvGlB;AAyGM;EACE,iBAAA;AAvGR;AA2GI;EACI,mBAAA;EACR,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,0BAAA;AA1GA;AA4GA;EACI,mBAAA;EACJ,yCAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mDAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,0BAAA;AA3GA;AA6GA;EACI,mBAAA;EACJ,wCAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,iDAAA;EACA,0BAAA;EACA,QAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA5GA;AA+GA;EACI,0BAAA;EACA,mBAAA;EACJ,gEAAA;EACA,0DAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,qDAAA;EACA,QAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9GA;AAgHA;EACI,aAAA;EACJ,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,+CAAA;EACA,mBAAA;EACA,wDAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9GA;AAgHA;EACI,mBAAA;EACJ,kDAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,+CAAA;EAEA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA/GA;AAiHA;EACI,yCAAA;EAEJ,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAhHA;AAmHA;EACI,cAAA;EACD,yBAAA;EACA,mBAAA;AAjHH;AAmHA;EACI,yCAAA;EAEJ,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAlHA;AAuHA;EACI,yCAAA;EAEJ,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AAtHA;AAyHA;EACI,aAAA;AAvHJ;AA0HA;EACI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gEAAA;EACA,gBAAA;EACA,wDAAA;AAxHJ;AA8HA;EACI,gBAAA;EACA,2BAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AA5HJ;AA+HA;EACI,2BAAA;AA7HJ;AAgIA;EACI,4BAAA;EACA,6BAAA;AA9HJ;AAiIA;EACI,8BAAA;EACA,mBAAA;EAOA,2BAAA;AArIJ;AAwIA;EACI,gBAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;AAtIJ;AAyIA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAvIJ;AA0IA;EACI,YAAA;AAxIJ;AA6IA;EACI,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0DAAA;EACA,uBAAA;AA3IJ;AA8IE;EACE,uBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,0BAAA;EACA,sCAAA;EACA,kBAAA;AA5IJ;AA+IA;EACI,iBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,YAAA;AA7IJ;AAgJA;EACI,iBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,YAAA;AA9IJ;AAiJA;EACI,YAAA;AA/IJ;AAkJA;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;AAhJJ;AAmJA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;AAjJJ;AAoJA;EACI,2CAAA;AAlJJ;AAuJA;EACI,iBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,aAAA;AArJJ;AAwJA;EACI,UAAA;AAtJJ;AAyJA;EACI,2BAAA;EAEA,iBAAA;AAxJJ;AA2JA;EACI,cAAA;AAzJJ;AA4JA;EACI,eAAA;AA1JJ;AA6JA;EACI,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AA3JJ;AA8JA;EACI,iBAAA;AA5JJ;AA+JA;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AA7JJ;AAgKA;EACI,YAAA;AA9JJ;AAiKA;EACI,gBAAA;EACA,eAAA;AA/JJ;AAkKA;EACI,eAAA;AAhKJ;AAmKA;EACI,YAAA;EACA,aAAA;EACA,YAAA;AAjKJ;AAqKA;EACI,2BAAA;AAnKJ;AA0KA;EACI,yDAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAxKJ;AA2KA;EACI,mCAAA;EACA,eAAA;AAzKJ;AA4KE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AA1KJ;AA6KE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AA3KJ;AA8KE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EAEA,gBAAA;AA5KJ;AA+KE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;AA7KJ;AAgLE;EACE,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AA9KJ;AAiLE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;AA/KJ;AAkLE;EACE,iDAAA;AAhLJ;AAmLE;EACE,wCAAA;AAjLJ;AAoLE;EAGE,2BAAA;EACA,yBAAA;AApLJ;AAwLE;EACE,mBAAA;AAtLJ;AAyLE;EACE,mBAAA;AAvLJ;AA0LE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAxLJ;AA2LE;EACE,aAAA;EACA,6BAAA;AAzLJ;AA4LE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;AA1LJ;AA6LE;EACE,kBAAA;EACA,aAAA;AA3LJ;AA8LE;EACE,kBAAA;EACA,aAAA;AA5LJ;AAgMA;EACI,UAAA;EACA,gBAAA;AA9LJ;AAkME;EACE,gBAAA;AAhMJ;AAoME;EACE,mBAAA;EACA,mBAAA;AAlMJ;AAsME;EACE,mBAAA;AApMJ;AAyMI;EACI,gBAAA;EACA,gBAAA;AAvMR;AA0MI;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAxMR;AA2MI;EACI,eAAA;EACA,gBAAA;AAzMR;AA4MI;EACI,YAAA;EACA,eAAA;AA1MR;AA6MI;EACI,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA3MR;AA8MI;EACI,kBAAA;AA5MR;AA+MI;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AA7MR;AAgNI;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AA9MR;AAiNI;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AA/MR;AAkNI;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAhNR;AAmNI;EACI,kBAAA;EAGA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gEAAA;EACA,gBAAA;AAnNR;AAwNI;EACI,yDAAA;EACA,4BAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAtNR;AAyNI;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAvNR;AA0NI;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AAxNR;AA2NK;EACG,gBAAA;EACA,eAAA;EACA,WAAA;AAzNR;AA4NK;EACG,eAAA;EACA,gBAAA;AA1NR;AA4NK;EACG,yBAAA;EACA,gCAAA;AA1NR;AA4NK;EACG,YAAA;AA1NR;AA4NK;EACG,YAAA;AA1NR;AA+NK;EACG,mBAAA;EACA,qDAAA;EACA,YAAA;EAEA,eAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gEAAA;AA9NR;AAiOM;EACE,cAAA;EACJ,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AA/NJ;AAkOM;EAEE,kBAAA;AAjOR;AAqOM;EACE,aAAA;EAEA,+BAAA;EACA,4BAAA;EACA,WAAA;EACA,mBAAA;EAEA,uBAAA;AArOR;AAwOM;EACE,wBAAA;EACA,UAAA;AAtOR;AA4OI;EACI,eAAA;EACA,MAAA;EACA,+BAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kFAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1OR;AA2OQ;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACP,gBAAA;EACA,eAAA;AAzOD;AA0OY;EACI,uBAAA;EACA,gBAAA;AAxOhB;AA0OC;EACG,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,8BAAA;AAxOJ;AA0OC;EACG,gBAAA;EACJ,yCAAA;EACA,uBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAzOA;AA2OA;EACI,yCAAA;AAzOJ;AA4OI;EACI,+BAAA;AA1OR;AA4OI;EACJ,0EAAA;AA1OA;AA2OQ;EACI,2EAAA;AAzOZ;AA0OY;EACI,0EAAA;AAxOhB;AAyOgB;EAAG,cAAA;AAtOnB;AA0OI;EACI,mBAAA;EACR,2EAAA;EACA,mDAAA;AAxOA;AA0OI;EACI,yCAAA;EAER,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAzOA;AA2OI;EAEJ,gEAAA;EACA,yDAAA;EACA,kBAAA;EACA,QAAA;EAgBA,SAAA;EACA,sDAAA;AAzPA;AA0OA;EACI,mBAAA;EACA,gFAAA;EAEA,eAAA;EACA,qDAAA;EACJ,gBAAA;EACA,eAAA;EACI,uBAAA;EACA,kBAAA;AAzOJ;AAgPA;EACI,yCAAA;EAEA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA/OJ;AAiPA;EACI,uDAAA;EAEJ,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAhPA;AAkPA;EACI,oDAAA;AAhPJ;AAkPA;EACI,kBAAA;EACJ,kDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhPA;AAkPA;EACI,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhPJ;AAkPA;EACI,kBAAA;EACJ,8DAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhPA;AAkPA;EACI,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhPJ;AAsPI;EACI,YAAA;EACA,qBAAA;EACA,YAAA;AApPR;AAsPI;EACI,mBAAA;EACJ,gEAAA;EACA,yDAAA;EAEA,SAAA;EACA,sDAAA;AArPJ;AAsPI;EACI,mBAAA;EACA,gEAAA;AApPR;AAsPI;EACI,mBAAA;EACA,gEAAA;AApPR;AAsPI;EACI,uDAAA;AApPR;AAsPI;EACI,mBAAA;EAEJ,YAAA;AArPJ;AA2PI;EAEI,gCAAA;EACA,qEAAA;EACA,uDAAA;EACA,gBAAA;AA1PR;AA4PI;EACI,gCAAA;EACA,sCAAA;AA1PR;AA6PM;EACE,qCAAA;AA3PR;AA6PI;EACI,2EAAA;AA3PR;AA6PI;EAEI,mBAAA;EACA,0DAAA;AA5PR;AA+PE;EACE,eAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7PJ;AA+PE;EACE,mBAAA;EACA,0EAAA;EACA,sEAAA;EAEA,iCAAA;EACA,kBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA/PJ;AAiQE;EACE,mBAAA;EACJ,gEAAA;AA/PA;AAiQE;EACE,mBAAA;EACA,0DAAA;AA/PJ;AAiQE;EACE,mBAAA;EACJ,gEAAA;EACA,6BAAA;EACA,yCAAA;EAEA,oCAAA;EACA,kBAAA;AAhQA;AAmQE;EACE,eAAA;EACA,uDAAA;AAjQJ;AAoQC;EACG,mBAAA;EACJ,wCAAA;EACA,kCAAA;EACA,iDAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAnQA;AAqQC;EAEG,mBAAA;EACJ,0CAAA;EACA,oCAAA;EACA,6CAAA;EAEA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArQA;AAuQC;EACG,8BAAA;AArQJ;AAuQC;EACG,sDAAA;AArQJ;AAuQC;EACG,uBAAA;EACA,0DAAA;EACJ,gBAAA;EACA,YAAA;EACA,qDAAA;EACA,0BAAA;EACA,cAAA;AArQA;AAuQC;EACD,gEAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AArQA;AAuQC;EACG,oCAAA;EACA,2BAAA;EACA,8BAAA;AArQJ;AAuQC;EACG,oCAAA;EACA,2BAAA;AArQJ;AAyQC;EACG,gEAAA;AAvQJ;AA2QC;EACG,kCAAA;AAzQJ;AA2QA;EACI,kBAAA;EACA,cAAA;EACA,mCAAA;EACA,mBAAA;EACA,0DAAA;EACA,gBAAA;EACA,wDAAA;AAzQJ;AA2QA;EACI,0DAAA;AAzQJ;AA4QA;EACI,gEAAA;EAEJ,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA3QA;AA6QA;EACI,+DAAA;EACA,uDAAA;AA3QJ;AA8QO;EACC,mBAAA;EACA,oEAAA;EACA,gEAAA;EAER,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA7QA;AA+QQ;EACI,uDAAA;EAEZ,iCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AA9QA;AAgRO;EACC,gEAAA;AA9QR;AAgRO;EACH,sDAAA;AA9QJ;AAgRO;EACC,mBAAA;EACR,0DAAA;EACA,gBAAA;EACA,qDAAA;AA9QA;AAgRO;EACP,0CAAA;EACA,4CAAA;EACA,sDAAA;AA9QA;AAmRA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,sBAAA;EACA,2BAAA;AAjRJ;AAqRA;EACI,gCAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,sBAAA;AAnRJ;AAuRA;EACI,0BAAA;AArRJ;AAwRA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,sBAAA;AAtRJ;AAyRA;EACI,YAAA;AAvRJ;AA0RA;EACI,kBAAA;AAxRJ;AA2RE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAzRJ;AA4RE;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AA1RJ;AA6RE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AA3RJ;AA4RI;EACI,qDAAA;EACA,UAAA;AA1RR;AA8RE;EACE,yBAAA;AA5RJ;AA+RA;EACI,YAAA;EACA,YAAA;EACA,sBAAA;EACA,oCAAA;EACA,8BAAA;EACA,gBAAA;AA7RJ;AAgSA;EACI,eAAA;EACE,qBAAA;EACA,qBAAA;AA9RN;AAiSA;EAEI,yBAAA;EACA,2DAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAhSJ;AAmSA;EACI,mBAAA;AAjSJ;AAsSA;EACI,gBAAA;EACA,YAAA;AApSJ;AAuSA;EACI,yCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AArSJ;AAwSA;EACI,kBAAA;EACA,mBAAA;EACA,8BAAA;AAtSJ;AA2SA;EACI,YAAA;AAzSJ;AA6SC;EACG,aAAA;AA3SJ;AA6SC;EACG,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA3SJ;AA6SC;EACG,kBAAA;AA3SJ;AA8SC;EAA0B,iBAAA;AA3S3B;AA6SC;EACG,kBAAA;AA3SJ;AA8SC;EAAiB,0BAAA;AA3SlB;AA6SC;EAAgD,mBAAA;EAAqB,gCAAA;EAAkC,kBAAA;EAAoB,cAAA;EAAgB,qBAAA;EAAuB,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,kBAAA;EAAoB,kBAAA;EAAoB,6BAAA;EAA+B,UAAA;EAAY,sBAAA;AA7RrT;AAiSC;EACG,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AA/RJ;AAkSC;EACG,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAhSJ;AAmSC;EACG,mBAAA;EACA,yBAAA;AAjSJ;AAoSC;EACG,eAAA;EACA,gBAAA;AAlSJ;AAuSC;EAAa,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,iBAAA;EAAmB,mBAAA;AAhShF;AAiSA;EAAoC,0BAAA;AA9RpC;AA+RC;EAAkC,0BAAA;AA5RnC;AA6RC;EAAuB,kBAAA;EAAoB,0BAAA;AAzR5C;AA0RA;EAAyC,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,iBAAA;EAAmB,mBAAA;AAnR3G;AAoRA;EAAkE,2CAAA;AAjRlE;AAkRA;EAAqC,kBAAA;EAAoB,QAAA;EAAU,SAAA;EAAW,yBAAA;EAA2B,yBAAA;EAA2B,UAAA;EAAY,kBAAA;EAAoB,kBAAA;EAAoB,mBAAA;EAAqB,wDAAA;AAtQ7M;AAuQA;EAA6D,YAAA;EAAc,SAAA;AAnQ3E;AAoQA;EAA+C,aAAA;EAAe,mBAAA;AAhQ9D;AAiQA;EAAuD,cAAA;AA9PvD;AA+PA;EAA+D,mBAAA;AA5P/D;AA6PA;EAAmD,sBAAA;EAAwB,iBAAA;EAAmB,iBAAA;AAxP9F;AAyPA;EACI,gEAAA;EACA,iBAAA;EACA,mBAAA;AAvPJ;;AA4PA;EAAe,SAAA;EAAW,2BAAA;EAA6B,UAAA;EAAY,iDAAA;EAAmD,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAA2B,kBAAA;EAAoB,mBAAA;AAhP3M;;AAiPA;EAAqB,WAAA;EAAa,QAAA;EAAU,SAAA;EAAW,YAAA;EAAc,cAAA;EAAgB,kBAAA;AAxOrF;;AAyOA;EAAoC,oCAAA;EAAsC,+BAAA;EAAiC,iCAAA;EAAoC,WAAA;EAAa,UAAA;AAjO5J;;AAmOA;EAA0B,kBAAA;EAAoB,qBAAA;EAAuB,WAAA;EAAa,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,eAAA;AAzNhJ;;AA0NA;EAA2C,sCAAA;AAtN3C;;AAuNA;EAAgC,UAAA;EAAY,QAAA;EAAU,SAAA;AAjNtD;;AAkNA;EAAuC,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,yBAAA;EAA2B,SAAA;EAAW,OAAA;EAAkC,gBAAA;AAtMlL;;AAuMA;EAA+C,sCAAA;EAA8G,2BAAA;EAAsD,gBAAA;AA9LnN;;AAgMA;EAAgB,gCAAA;EAAkC,oBAAA;EAAsB,mBAAA;AA1LxE;;AA2LA;EAAsB,yBAAA;EAA2B,kBAAA;AAtLjD;;AAuLA;EAAwC,mBAAA;AAnLxC;;AAoLA;EACI,kBAAA;EAAoB,UAAA;EAAW,WAAA;EAAa,gEAAA;EAAiE,+DAAA;EAAiE,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,iBAAA;AAzKjO;AA0KI;EAAO,gBAAA;EAAkB,iBAAA;AAtK7B;;AAyKA;EAAkB,qBAAA;AArKlB;;AAwKA;EAAmB,kBAAA;AApKnB;;AAqKA;EAAwD,uBAAA;EAAyB,SAAA;EAAW,kBAAA;EAAoB,eAAA;EAAiB,YAAA;EAAc,OAAA;EAAS,kBAAA;EAAoB,QAAA;EAAU,MAAA;EAAQ,WAAA;AAxJ9L;;AAyJA;EAA2B,kBAAA;EAAoB,kCAAA;EAAoC,gBAAA;EAAkB,qBAAA;EAAuB,kBAAA;EAAoB,sBAAA;EAAwB,gBAAA;EAAkB,QAAA;EAAU,QAAA;EAAU,2BAAA;AA5I9M;;AA8IA;EAA2B,iFAAA;AA1I3B;;AA2IA;EAA0B,WAAA;EAAa,cAAA;EAAgB,wBAAA;EAA0B,YAAA;EAAc,cAAA;EAAgB,0DAAA;AAlI/G","sourcesContent":[".lightTheme{\n    text{\n        fill: black !important;\n    }\n    .main-wrapper{\n        transition: all 0.25s ease-in;\n        overflow: hidden;\n        position: relative;\n        margin: 0;\n        max-height: 100vh;\n      padding: 0;\n      background: var(--foundation-neutral-neutral-200, #EFF3F9); \n     min-height: 100vh; \n     transition:all 0.2s ease-in-out;\n    }\n    .content-body{\n        margin-left: 15rem;\n        margin-bottom: 1rem;\n        margin-right: 1rem;\n        transition: margin-left 0.4s ease;\n \n    }\n    .todo{\n        border-radius: 14px;\nborder: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\nbackground: #FFF;\nz-index: 1;\n\n/* popover */\nbox-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\n    }\n    //text for light\n    .text-custom{\n        color: var(--text-high-emphasis, #090826);\n    }\n\n    //for enabling scroll on all the screen\n\n    .celVQH{\n        //     overflow-y: auto;\n        //    max-height: 67vh;\n        overflow-y: auto;\n        max-height: 28vh;\n    }\n\n    @media(min-width: 1600px) {\n    .celVQH{\n    overflow-y: auto;\n    max-height: 45vh;\n    }\n\n    .permission-page{\n        overflow: scroll;\n        height: 55vh;\n    }\n\n}\n    .content-body-collapse{\n        margin-left: 6rem;\n      \n        margin-bottom: 1rem;\n        margin-right: 1rem;\n        transition: margin-left 0.4s ease;\n    \n    }\n    .button-toggle{\n        /* margin-right: -1.8rem; */\n        position: absolute;\n        right: -10px;\n        bottom: -25px;\n    }\n\n    .user-img {\n        display: block;\n        width: 30px;\n        height: 30px;\n        object-fit: cover;\n    }\n\n    .nav-options-nested-option{\n        color: var(--text-white-high-emphasis, #FCFCFE);\n        border-radius: 14px;\n        font-family: Inter;\n        font-size: 0.7rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n        margin-top: -45px;\n        margin-bottom: 15px;\n        margin-left: 39px;\n    }\n\n    .activeOption {\n        border-radius: 14px;\n        background: var(--primary);\n        color: black;\n        /* background: var(--primary-opactiy-20); */\n        /* color: #333; */\n        /* background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzI1NzlfNzc2MjAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjU3OV83NzYyMCkiPgo8cGF0aCBkPSJNOC4yMjkxNyAxMS45Mzc1TDEzLjcyOTIgNi40NTgzNEMxMy44ODE5IDYuMzA1NTYgMTQuMDU1NiA2LjIzMjY0IDE0LjI1IDYuMjM5NTlDMTQuNDQ0NCA2LjI0NjUzIDE0LjYxODEgNi4zMjYzOSAxNC43NzA4IDYuNDc5MTdDMTQuOTIzNiA2LjYzMTk1IDE1IDYuODA1NTYgMTUgNy4wMDAwMUMxNSA3LjE5NDQ1IDE0LjkyMzYgNy4zNjgwNiAxNC43NzA4IDcuNTIwODRMOC43NzA4MyAxMy41MjA4QzguNjE4MDYgMTMuNjczNiA4LjQ0MDk3IDEzLjc1IDguMjM5NTggMTMuNzVDOC4wMzgxOSAxMy43NSA3Ljg2MTExIDEzLjY3MzYgNy43MDgzMyAxMy41MjA4TDUuMjI5MTcgMTEuMDQxN0M1LjA3NjM5IDEwLjg4ODkgNSAxMC43MTUzIDUgMTAuNTIwOEM1IDEwLjMyNjQgNS4wNzYzOSAxMC4xNTI4IDUuMjI5MTcgMTBDNS4zODE5NCA5Ljg0NzIzIDUuNTU1NTYgOS43NzA4NCA1Ljc1IDkuNzcwODRDNS45NDQ0NCA5Ljc3MDg0IDYuMTE4MDYgOS44NDcyMyA2LjI3MDgzIDEwTDguMjI5MTcgMTEuOTM3NVoiIGZpbGw9IiMwOTA4MjYiLz4KPC9nPgo8L3N2Zz4K); */\n        background-repeat: no-repeat;\n        background-position: left;\n    }\n\n    .nav-options{\n        color: var(--text-white-high-emphasis, #FCFCFE);\n     \n        border-radius: 14px; \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    //width: 11.9rem \n    }\n\n    .nav-options-hovered{\n        color:black;\n        background: var(--primary);\n        border-radius: 14px; \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    width: 11.9rem ;\n    }\n\n    .nav-options:hover{\n        background: var(--primary);\n        color: #002d72;\n        font-weight: 600;\n    }\n    .nav-options:active{\n        background: var(--primary);\n        color: #002d72;\n        font-weight: 600;\n    }\n    .nav-options:focus{\n        background: var(--primary);\n        color: #002d72;\n        font-weight: 600;\n    }\n    .toggleSwitch{\n        background: var(--foundation-neutral-neutral-500, #DCE4F1);\n    \n    }\n\n    //neted nav options\n\n    .nav-options-nested{\n        color: var(--text-white-high-emphasis, #FCFCFE);\n        display: flex;\n        justify-content: space-between;\n     \n        border-radius: 14px; \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.6rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    }\n    .nav-options-nested:hover{\n        background: var(--primary);\n        color: black;\n        font-weight: 600;\n    }\n   \n    // css for banner\n    .banner{\n        margin:1rem;\n       \n        margin-left: 15rem;\n         background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);\n        \n     }\n     .banner-collapse{\n        \n         margin:1rem;\n         margin-left: 6rem;\n         background: linear-gradient(269deg, var(--primary) 14.5%, var(--secondary-700) 87.34%, var(--secondary-700) 87.34%);\n     }\n     .txt-title{\n         color: var(--text-white-high-emphasis, #FCFCFE);\n     \n         /* Typography/Heading 5/Bold */\n         \n         font-size: 1rem;\n         font-style: normal;\n         font-weight: 600;\n         line-height: 120%; /* 28.8px */  \n     }\n     .table-custom{\n        background:white;\n        height: 89vh;\n        //overflow-y: auto;\n        border-radius: 12px;\n     }\n     \n     .btn-banner{\n        \n     border: 2px solid rgba(255, 255, 255, 0.80);\n     background: var(--foundation-secondary-secondary-400, var(--primary));\n     box-shadow: 0px 10px 31px 0px var(--primary-opactiy-40);\n     color: #323146;\n     \n     /* Typography/Body/Default/Bold */\n     font-family: Inter;\n     font-size: 0.7rem;\n     font-style: normal;\n     font-weight: 600;\n     line-height: 120%; /* 16.8px */\n     }\n    //  css for top header \n\n    .headerTop{\n        margin-left:12rem;\n        display:flex;\n        align-items: center;\n        justify-content: flex-end;\n        border-bottom: 1px solid  #E3E9F4; \n        }\n        .headerTop-collapse{\n            margin-left:4rem;\n        border-bottom: 1px solid  #E3E9F4; \n          \n            display:flex;\n        align-items: center;\n        justify-content: flex-end;\n        }\n        .fa-circle{\n            font-size: 8px;\n        }\n        .headerSecond{\n            margin-left: 14rem ;\n            display:flex;\n            align-items: center;\n            justify-content:space-between;\n        }\n        .headerSecond-collapse{\n            margin-left:5rem;\n            display:flex;\n            align-items: center;\n            justify-content:space-between;\n        }\n        .image-logo{\n        border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4); \n        }\n        .fa-lock{\n            color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60)); \n            font-size: 10px;\n        }\n        .image-logo-second{\n            color: var(--text-high-emphasis, #090826);\n        \n        /* Typography/Heading 5/Bold */\n        \n        font-size: 1rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 28.8px */\n        }\n        .groupid{\n            color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n        \n        /* Typography/Body/Default/Regular */\n        font-family: Inter;\n        font-size: 0.6rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%; /* 18.2px */\n        }\n        .bell{\n        border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n        }\n        .sub-grp{\n            border-radius: 14px;\n            border: 2px solid var(--primary);\n            background: var(--foundation-secondary-secondary-400, var(--primary));\n            color: var(--text-high-emphasis, #090826);\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 120%;\n        }\n\n        .delete-obj{\n            background: var(--Error-error-button-enabled, #FF6969);\n            box-shadow: 0px 10px 31px 0px #FF696966;\n            font-weight: 600;\n        }\n        .sub-grp:hover{\n            background: var(--secondary-300);\n            //border: 2px solid var(--secondary-300);\n        }\n        .notificationcard{\n            position: absolute;\n            /* bottom:0; */\n            top:18px;\n           right:0;\n            z-index: 1000;\n            width:300px;\n           \n            border-radius: 14px;\n        border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n        background: #FFF;\n        \n        /* popover */\n        box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\n        }\n        \n        .bgOne{\n            background: var(--foundation-neutral-neutral-500, #DCE4F1);\n        }\n        .notification{\n            color: var(--text-high-emphasis, #090826);\n        \n        /* Typography/Body/Large/Regular */\n        font-size: 0.7rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 120%;\n        text-align: left;\n        z-index: 100000000;\n        }\n        .notification-card{\n            border-top: 1px solid #E3E9F4;\n           \n        }\n        .notification-card:hover{\n            border-radius: 14px;\n            background: var(--foundation-neutral-neutral-400, #E3E9F4);\n        }\n        .notification-img{\n            border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4); \n            height: 40px; \n        min-width: 40px;\n        }\n        .notification-heading{\n            color: var(--text-high-emphasis, #090826);\n        /* Typography/Heading 6/Bold */\n        font-family: Inter;\n        text-align: left;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 24px */ \n        }\n        .notification-description{\n            color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n        text-align: left;\n        /* Typography/Body/Default/Regular */\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%; /* 18.2px */\n        }\n        .profile{\n            z-index: 1000;\n        }\n        .profile-name{\n            color: var(--text-high-emphasis, #090826);\n        \n        /* Typography/Body/Default/Bold */\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%; /* 16.8px */\n        }\n        .isactive{\n            // color: var(--text-high-emphasis, #090826);\n        \n        /* Typography/Body/Default/Regular */\n        font-family: Inter;\n        font-size: 0.7rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%; /* 18.2px */\n        }\n        .profileCards{\n            border-top: 1px solid #E3E9F4;\n          \n            // color: var(--text-high-emphasis, #090826);\n        \n            /* Typography/Body/Default/Regular */\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 130%; /* 18.2px */\n        }\n        .profilehover:hover{\n            border-radius: 14px;\n            background: var(--foundation-neutral-neutral-400, #E3E9F4);\n        }\n        .profileCards{\n            display: flex;\n            flex-direction: column;\n        }\n    //  css for main subgroup table \n    .lffUrX:not(:last-of-type){\n        border:none  !important;\n    }\n    .tab{\n        border-radius: 14px;\n        color: var( --text-high-emphasis);\n        display: flex;\n     \n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 12px;\n        /* Typography/Body/Default/Bold */\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 130%; /* 18.2px */\n        background-color: var(--secondary-50);\n     position: relative;\n     \n    }\n\n    .type-roles{\n          display: flex;\n          padding: 4px 6px 4px 7px;\n          align-items: center;\n          //gap: 8px;\n          justify-content: space-between;\n          border-radius: 54px;\n          border: 2px solid #C8CFDB;\n          background:#E3E9F4;\n          color: #090826;\n          width: 129px;\n          \n          /* Typography/Body/Small/Regular */\n          font-family: Inter;\n          font-size: 0.8rem;\n          font-style: normal;\n          font-weight: 400;\n          line-height: 120%; /* 14.4px */\n    }\n\n    .tab.form{\n        color: var(--secondary-500);\n    }\n    .tab::before{\n    content:'';\n    position:absolute;\n    height: 4px;\n    bottom: 0;\n    border-radius: 20px;\n    width:70%;\n    align-self: center;\n    background-color: var(--secondary-500);\n    }\n\n\n    .tab.form::before {\n\n        position:absolute;\n        height: 4px;\n        bottom: 0;\n        border-radius: 20px;\n        width:70%;\n        align-self: center;\n        background-color: var(--secondary-50);\n\n    }\n    .tab-unactive{\n        color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.6));\n        align-self: flex-start;\n        //justify-self: center;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 130%;\n    }\n    \n    \n      \n      input:focus {padding: none;\n        outline: none !important}\n        .search-input::placeholder {\n            color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n            /* Typography/Body/Default/Bold */\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 120%; /* 16.8px */\n            text-align: right;\n          \n          \n            color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n            /* Typography/Body/Default/Bold */\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 120%; /* 16.8px */\n          }\n          .search-input, .custom-input{\n           padding-right:20px ;\n           border-radius: 14px;\n           border: 2px solid var(--main-neutral-neutral-400, #E3E9F4);\n            font-size: 0.8rem;\n          }\n         \n          .fa-chevron-down{\n            color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    \n    \n          }\n          .text-style{\n            color: var(--text-high-emphasis, #090826);\n    \n            /* Typography/Body/Default/Bold */\n            font-family: Inter;\n            font-size: 0.8rem;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 120%; /* 16.8px */\n          }\n          .iGDrkx{\n            min-height: 0px !important;\n            padding: 0 !important;\n          }\n          .fa-chevron-right{\n            color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60)); \n          }\n          .lffUrX{\n            min-height: 60px !important;\n          }\n    \n    .text-heading{\n        color: var(--text-high-emphasis, #090826);\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n    word-break: normal !important;\n    max-width: 6vw;\n    /* white-space: nowrap; */\n    overflow: hidden;\n    text-overflow: ellipsis;\n    }\n\n    .desc-box{\n        max-width: 14vw;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    }\n    .text-detail{\n      color: var(--text-high-emphasis, #090826);    \n    font-size: 0.7rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .type-department{\n      cursor: pointer;\n      display: flex;\n    align-items: center;\n    gap: 8px;\n    border-radius: 54px;\n    border: 2px solid rgba(255, 146, 81, 0.50);\n    background: rgba(255, 146, 81, 0.20);\n    color: var(--foundation-orange-orange-800, #8C502D);\n    padding: 4px 16px 4px 12px;\n    /* Typography/Body/Small/Regular */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .type-initiated{\n        display: flex;\n      align-items: center;\n      gap: 8px;\n      border-radius: 54px;\n      border: 2px solid var(--secondary-300);\n      background: #d4ebf2;\n      color:  #3590ae;\n      padding: 4px 16px 4px 12px;\n      /* Typography/Body/Small/Regular */\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%; /* 14.4px */\n      }\n    .type-project{\n      display: flex;\n    padding: 4px 16px 4px 12px;\n    align-items: center;\n    gap: 8px;\n    border-radius: 54px;\n    border: 2px solid rgba(157, 110, 248, 0.50);\n    background: rgba(157, 110, 248, 0.20);\n    color: var(--foundation-purple-purple-800, #563D88);\n    \n    /* Typography/Body/Small/Regular */\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .type-Client{\n        cursor: pointer;\n      display: flex;\n    padding: 4px 16px 4px 12px;\n    align-items: center;\n    gap: 8px;\n    border-radius: 54px;\n    border: 2px solid rgba(106, 218, 0, 0.50);\n    background: rgba(106, 218, 0, 0.20);\n    color: var(--foundation-green-green-800, #3A7800);\n    \n    /* Typography/Body/Small/Regular */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n    .type-pending-provision{\n      display: flex;\n    padding: 4px 16px 4px 12px;\n    align-items: center;\n    gap: 8px;\n    border-radius: 54px;\n    border: 2px solid #F6B63780;\n    background: #F6B63733;\n    color:#87641E;\n    \n    /* Typography/Body/Small/Regular */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 14.4px */\n    }\n\n    .type-requested{\n        display: flex;\n      padding: 4px 16px 4px 12px;\n      align-items: center;\n      gap: 8px;\n      border-radius: 54px;\n      border: 2px solid var(--secondary-300)80;\n      background: #F6B63733;\n      color:#87641E;\n      \n      /* Typography/Body/Small/Regular */\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 120%; /* 14.4px */\n    }\n\n    .folder{\n      color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    text-align: center;\n    \n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 19.2px */\n    color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size:  0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    }\n    .setting{\n      color: var(--text-high-emphasis, #090826);\n      width: 120px;\n      \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%; /* 16.8px */\n    }\n    .member{\n      color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n    text-align: center;\n    \n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 19.2px */\n    }\n    .folder-0{\n      color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 120%; /* 16.8px */\n    }\n    .setting-0{\n      color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32));\n    text-align: center;\n    width: 120px;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 19.2px */\n    }\n    .cQAWmj{\n     \n    /* height: 20px!important; */\n    min-height: 0px !important;\n    }\n    .lhMoHC{\n      min-width: 50px !important;\n    }\n    .lffUrX:hover {\n      background-color: #F1F1F4 !important;\n      border-radius: 14px !important;\n    }\n    // sidebar css  \n    .Navheader{\n        width: 13.7rem;\n        transition: width 0.4s ease;\n        // background: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #4C4B4B);\n        background: #002d72;\n      position: fixed; \n      top:0;\n      bottom:0;\n      z-index: 9;\n    }\n    .Navheader-collapse{\n        width: 5rem;\n        transition: width 0.4s ease;\n        background: #002d72;\n      position: fixed; \n      top:0;\n      bottom:0;\n      z-index: 1000000000;\n    //   height: auto;\n    //   overflow: hidden;\n    //   transition: height 0.3s ease;\n    \n    }\n\n    .under-dev-img{\n        height: 80vh;\n        width: 650px;\n        background: rgba(0, 0, 0, .6);\n        opacity:0.35;\n    }\n\n    .under-dev{\n        font-size: 25px;\n        opacity:0.35;\n    }\n    .coming-soon{\n        background: white;\n        align-items: center;\n    }\n    .dbtez{\n        /* width: 11.5rem; */\n        width: 8.5rem;\n    transition: width 0.4s ease;\n    }\n    .icon{\n        width:40px;\n        font-size: 1.3rem;\n        transition: width 0.4s ease;\n    }\n    .icon-collapse{\n        font-size: 1.1rem;\n        width:auto;\n        transition: width 0.4s ease;\n    }\n    .navoptionsallcollapse::-webkit-scrollbar-track {\n        background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B); /* Change this to match your sidebar's background color */\n        padding-left: 10px;\n    }\n    \n    /* Style the scrollbar thumb */\n    .navoptionsallcollapse::-webkit-scrollbar-thumb {\n        background-color: #666; /* Change this to match the color you want for the scrollbar thumb */\n        border-radius: 10px; /* Adjust border radius as needed */\n    }\n    \n    /* Style the scrollbar on hover */\n    .navoptionsallcollapse::-webkit-scrollbar-thumb:hover {\n        background-color: #999; /* Change this to a lighter shade for hover effect */\n    }\n    .navoptionsall::-webkit-scrollbar-track {\n        background-color: var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B); /* Change this to match your sidebar's background color */\n        padding-left: 10px;\n    }\n    \n    /* Style the scrollbar thumb */\n    .navoptionsall::-webkit-scrollbar-thumb {\n        background-color: #666; /* Change this to match the color you want for the scrollbar thumb */\n        border-radius: 10px; /* Adjust border radius as needed */\n    }\n    \n    /* Style the scrollbar on hover */\n    .navoptionsall::-webkit-scrollbar-thumb:hover {\n        background-color: #999; /* Change this to a lighter shade for hover effect */\n    }\n    \n    .navoptionsall{\n        height: 80vh;\n        //border-top: 2px solid #6d6f6fa2;\n        width: auto;\n        transition: width 0.4s ease;\n        margin-right: 5px;\n        margin-top: 33px;\n    }\n\n    // @media (min-height: 774px) {\n    //     .navoptionsall {\n    //         overflow-y: hidden; \n    //     }\n    // }\n    .dbtez{\n        /* border-radius: 14px; */\n    border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-300, #858686);\n    background: rgba(255, 255, 255, 0.20);\n    align-items: center;\n    }\n    .row-label{\n        color: var(--text-high-emphasis, #090826);\n    \n    /* Typography/Body/Default/Bold */\n    \n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    }\n    .fEnJOm{\n        min-height: 0 !important;\n        display: flex;\n    /* padding: 8px 16px 8px 64px; */\n    align-items: center;\n    align-self: stretch;\n    margin: 4px;\n    margin-top: 12px;\n    \n    border-bottom:none !important;\n        border-radius: 14px !important;\n        padding-top: 2px;\n        padding-bottom: 2px;\n    background: var(--foundation-neutral-neutral-400, #E3E9F4) !important;\n    }\n    .navoptionsallcollapse{\n        border-top: none;\n        height: 80vh;\n        margin-top: 33px;\n        //border-top: 2px solid rgba(109, 111, 111, 0.6352941176);\n        width: auto;\n        transition: width 0.4s ease;\n        margin-right: 5px;\n        z-index: 20000000 !important;\n\n        .optionsDropdownCard{\n            background:\n                linear-gradient(var(--primary-opactiy-20), var(--primary-opactiy-20)),\n                linear-gradient(var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B), var(--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B)) top;\n            border-radius: 14px;\n            transform: translate(60px, -50%);\n        }\n\n        .nav-options.activeOption {z-index: 9999999 !important;}\n        &:has(.optionsDropdownCard){overflow-y: visible; position: relative; z-index: -1 !important;}\n    }\n    .options-dropdown{\n        width: 11.5rem;\n    }\n    .optionsDropdownCard{\n        margin-top: -20px;\n        /* position: relative;\n        bottom: 0; */\n        /* top: 255px; */\n        font-size: 18px;\n        /* left: 9px; */\n        z-index: 999999;\n        /* color: white; */\n        width: 11.8rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-bottom-left-radius: 14px;\n        border-bottom-right-radius: 14px;\n        background: var(--primary-opactiy-20);\n        border: 1px solid var(--primary-opactiy-20);\n        box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);\n    }\n\n    .options-heading-submenu{\n        overflow: hidden;\n        // color: white;\n        /* text-overflow: unset; */\n        margin-left: 23px;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n        color: white;\n    }\n    .options-heading-submenu:hover{\n      \n        color: black;\n    }\n    .organisationDropdownCard{\n        position: absolute;\n        /* bottom:0; */\n        /* top: 40px;\n        left: 20px; */\n        left: 0;\n        top: 92%;\n        z-index: 200000000 !important;\n        width:11rem;\n       display: flex;\n       flex-direction: column;\n       justify-content: center;\n       align-items: center;\n        border-radius: 14px;\n    border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n    background: #FFF;\n    \n    /* popover */\n    box-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\n    >div {width: 100%;}\n    }\n\n    .select-custom-input{\n        flex: 1 1;\n        padding: 10px;\n        box-sizing: border-box;\n        border: 2px solid #E3E9F4;\n        border-radius: 12px;\n        width: 425px;\n        margin-bottom: 15px;\n    }\n    .organisations{\n        max-height: 40vh;\n    overflow: auto;\n    border-top: 2px solid  #E3E9F4;\n    border-bottom: 2px solid  #E3E9F4;\n    \n    }\n    .organisation-img{\n        width: 19px;\n        display: block;\n        border: 1px solid #E3E9F4;\n        padding: 2px;\n    }\n\n    .nav-options-heading {\n\n        overflow: hidden;\n    color: white;\n    /* text-overflow: unset; */\n    margin-left: 23px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n\n    }\n\n    .options-heading {\n\n        overflow: hidden;\n    color: black;\n    /* text-overflow: unset; */\n    margin-left: 23px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n\n    }\n\n    .roles-heading{\n        color: black;\n    margin-left: 23px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n    }\n\n    .options-heading-active {\n\n        overflow: hidden;\n    color: black;\n    /* text-overflow: unset; */\n    margin-left: 23px;\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n\n    }\n    .textBlack{\n        color: black\n    }\n    .textBlue{\n        color:  #002d72;\n    }\n    .organisation-heading{\n        overflow: hidden;\n    color: var(--text-high-emphasis, #090826);\n    text-overflow: ellipsis;\n    \n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    /* line-height: 120%; 16.8px */\n    }\n    .oragnisationHover{\n        cursor: pointer;\n        button {\n            font-size: 10px;\n            color: #09082652;\n            display: block;\n            i {display: block;}\n        }\n    }\n    .oragnisationHover:hover{\n        border-radius: 14px;\n        background: var(--primary);\n        color: black !important;\n    \n    }\n\n    .oragnisationHover:focus{\n        border-radius: 14px;\n    background: var(--primary)33;\n    color: black;\n    \n    }\n    #orgHover:hover{\n        color: black;\n    }\n\n    .oragnisationHover:active{\n        border-radius: 14px;\n        background: var(--primary)33;\n    \n    }\n    \n    .oragnisationHover{\n        cursor: pointer;\n    }\n    .new:hover{\n        cursor: pointer;\n    }\n    .nav-options{\n        position: relative;\n        z-index: 20 !important;\n    }\n    .tooltip {\n        display: flex;\n        position: absolute;\n        background: #fcfcfe;\n        color: var(--text-high-emphasis, #090826);\n        gap: 8px;\n        font-family: Inter;\n        font-size: 0.8rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 130%;\n        padding: 5px;\n        width: max-content;\n        border-radius: 4px;\n        top: 10px;\n        left: 50px;\n        z-index: 9000000000000000 !important;\n        text-align: justify;\n        &.tooltip-top {\n            left: 50%; transform: translateX(-50%); top: -18px; box-shadow: 3px 4px 16px 0 rgba(0, 11, 65, 0.15); padding: 2px 5px;\n            &:after{content: \"\"; width: 0; height: 0; border-left: 5px solid transparent; border-right: 5px solid transparent; border-top: 5px solid #ffffff; font-size: 0; line-height: 0; position: absolute; bottom: -5px; left: calc(50% - 5px);}\n        }\n        &.hidden {display: none;}\n      }\n      .plus-icon{\n        margin-left: 16px;\n      }\n     \n    //tabletask\n    .status{\n        border-radius: 54px;\nborder: 2px solid;\nalign-items: center;\ndisplay: flex;\njustify-content: center;\ngap:8px;\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\npadding: 4px 16px 4px 12px;\n    }\n.status-inprogress{\n    border-radius: 54px;\nborder: 2px solid rgba(255, 146, 81, 0.50);\nbackground: rgba(255, 146, 81, 0.20);\nalign-items: center;\ndisplay: flex;\njustify-content: center;\ngap:8px;\ncolor: var(--foundation-orange-orange-800, #8C502D);\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\npadding: 4px 16px 4px 12px; \n}\n.status-done{\n    border-radius: 54px;\nborder: 2px solid rgba(106, 218, 0, 0.50);\nbackground: rgba(106, 218, 0, 0.20);\nalign-items: center;\ndisplay: flex;\njustify-content: center;\ncolor: var(--foundation-green-green-800, #3A7800);\npadding: 4px 16px 4px 12px; \ngap:8px;\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n\n}\n.status-backlog{\n    padding: 4px 16px 4px 12px; \n    border-radius: 54px;\nborder: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);\nbackground: var(--foundation-neutral-neutral-200, #EFF3F9);\nalign-items: center;\ndisplay: flex;\njustify-content: center;\ncolor: var(--foundation-neutral-neutral-900, #5C6065);\ngap:8px;\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n}\n.dueto-today{\n    display: flex;\nheight: 32px;\npadding: 0px 8px 0px 12px;\nalign-items: center;\ngap: 4px;\ncolor: var(--text-white-high-emphasis, #FCFCFE);\nborder-radius: 20px;\nbackground: var(--foundation-orange-orange-500, #FF9251);\n/* Typography/Body/Small/Bold */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 14.4px */\n}\n.dueto-past{\n    border-radius: 20px;\nbackground: var(--foundation-red-red-500, #FF6969);\ndisplay: flex;\nheight: 32px;\npadding: 0px 8px 0px 12px;\nalign-items: center;\ngap: 4px;\ncolor: var(--text-white-high-emphasis, #FCFCFE);\n\n/* Typography/Body/Small/Bold */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 14.4px */\n}\n.duto-text{\n    color: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n}\n// element progress bar\n.progressbar{\n    color:#E3E9F4;\n   background-color: #E3E9F4;\n   border-radius: 14px;\n}\n.task{\n    color: var(--text-high-emphasis, #090826);\n\n/* Typography/Heading 5/Bold */\nfont-family: Inter;\nfont-size: 24px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 28.8px */\n}\n\n//members table css \n\n.members{\n    color: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Large/Regular */\nfont-size: 0.7rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%;\ntext-align: left;\nborder-bottom: 1px solid #E3E9F4;\n}\n\n.member-dropdown{\n    height: 200px;\n}\n\n.memberscard {\n    position: absolute;\n    /* bottom: 0; */\n    top: 32px;\n    left: -115px;\n    right: 0;\n    z-index: 1000;\n    width: 300px;\n    border-radius: 14px;\n    border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n    background: #FFF;\n    box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);\n}\n\n\n//createUser Popup\n\n.generate-password {\n    min-width: 252px;\n    min-height: 22px !important;\n    flex: 1 1;\n    padding: 7px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    margin-right: 12px;\n}\n\n.rdt_TableRow{\n    min-height: auto !important;\n}\n\n.rdt_TableCell{\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n}\n\n.rdt_TableHeadRow{\n    background: #E3E9F4 !important;\n    border-radius: 12px;\n    //border-radius: 93px;\n    // border-bottom-width: none !important;\n    // border-bottom-color: none!important;\n    // border-bottom-style: none!important; \n    // border-bottom-right-radius: 20px;\n    // border-bottom-left-radius: 20px;\n    min-height: 38px !important;\n}\n\n.rdt_TableBody{\n    overflow: scroll;\n    height: calc(100vh - 305px);\n    padding-bottom: 60px;\n    padding-right: 8px;\n}\n\n.toggle-password {\n    position: absolute;\n    right: 20px;\n    top: 13px;\n    cursor: pointer;\n}\n\n.email-field{\n    height: 22px;\n}\n\n//editUser Popup\n\ninput[type='checkbox']{\n    width: 18px !important;\n    height: 18px !important;\n    margin-right: 10px;\n    margin-top: 5px;\n    -o-appearance: none;\n    appearance: none;\n    box-shadow: none;\n    font-size: 0.8em;\n    text-align: center;\n    line-height: 1.20em;\n    background: var(--foundation-neutral-neutral-100, #F4F7FB);\n    border:2px solid black;\n  }\n  \n  input[type='checkbox']:checked:after {\n    height: 20px !important;\n    content: \"🗸\";\n    padding: 2px;\n    font-weight: 600;\n    font-size: 1rem;\n    color: white;\n    background: var(--primary);\n    border: 2px solid var(--secondary-700);\n    border-radius: 1px;\n  }\n\n.edit-user {\n    background: white;\n    height: fit-content;\n    width: 595px;\n}\n\n.edit-category {\n    background: white;\n    height: fit-content  ;\n    width: 595px;\n}\n\n.input-field{\n    width: 245px\n}\n\n.toggle-bg{\n    position: relative;\n    display: inline-block;\n    width: 180px;\n    height: 31px;\n}\n\n.toggle-slider{\n    position: absolute;\n    content: \"\";\n    height: 31px;\n    width: 95px;\n    left: -17px;\n    top: 0px;\n    background-color: #9CA2AB;\n    transition: 0.4s;\n}\n\ninput[type=checkbox]:checked + label:before{\n    background-color: var(--primary) !important;\n}\n\n//teamInfoPopupCss\n\n.teamInfoPopup {\n    background: white;\n    height: fit-content;\n    width: 1050px;\n}\n\n.teamInfoGrid {\n    gap: 34rem\n}\n\n.vl {\n    border-left: 1px solid #ccc;\n    //height: 60px;\n    margin-top: -94px;\n  }\n\n.small-text{\n    font-size: 8px;\n}\n\n.badge-text{\n    font-size: 11px;\n}\n\n.team-name {\n    min-width: 630px;\n    flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.teamInfoSidebar{\n    margin-left: 50px;\n}\n\n.info-badge{\n    background-color: #EFF3F9;\n    padding: 5px;\n    width: 185px;\n    border-radius: 15px;\n}\n\n.badge-icon {\n    margin: 12px;\n}\n\n.popup-text{\n    font-weight: 500;\n    font-size: 13px;\n}\n\n.date-text {\n    font-size: 11px;\n}\n\n.profile-cover{\n    width: 145px;\n    height: 145px;\n    margin: 15px;\n    //margin-top: -80px;\n}\n\n.img-div{\n    border-left: 1px solid #ccc;\n}\n\n// .team-label{\n//     height: 480px;\n// }\n\n.team-mate {\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFLSURBVHgBnZLfTcMwEMbv7Lhx/RQ2sASuEC+UDdoNwgSUDViBDWCCZgPYoGWC8ogEEt6APiGranLYSaiqJqmqfJJj6/78fPlkhD0liU6cEykA6ipSLJ37WsIR4f9BqfOUcj73keSgxhJsps5Z2wZgu+aCv9TEx20e3RCwKUN69iGNJFZCmDF0aShH32FJqfVhLjT6HA2lWbQ2KzVKQ4GUZtZ5wdA8VTXNC1hRQDlansN7F4CI1zkxaQCIcA0ni9sGADEv6Zxj2tXGoJhUJ2dbC0oTY/PT5nQcXzzUHs3beqPw2eZ0GzFcRBxWnJvMh97q/B0CTqop2rV7SFJeaobFKxFc7xcQUMYAkUoYZb/u874xQfl37sP6bSzElV9bHWKDwWa5XtvSZCVHHoYzJQ0cQk6Wh2TBD9XhRy8IQg8FSPAklpsz6Ktgetj/ANwtaoEESpAOAAAAAElFTkSuQmCC);\n    background-repeat: no-repeat;\n    background-position: 9px 14px;\n    min-width: 470px;\n    flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    margin-right: 12px;\n    padding-left: 29px;\n}\n\n.team-mate::placeholder {\n    color:#09082652;\n    font-size: 13px;\n  }\n\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 35px;\n    height: 12px;\n  }\n  \n  .switch input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #E3E9F4;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n  \n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 31px;\n    width: 95px;\n    left: 0px;\n    top: 0px;\n    background-color: #88E133;\n    transition: 0.4s;\n  }\n\n  .toggle-btn-text{\n    position: absolute;\n    top:6px;\n    margin-left:17px;\n    font-weight:500;\n  }\n\n  .toggle-btn-dis-text{\n    position: absolute;\n    top:6px;\n    margin-left:104px;\n    font-weight:500;\n  }\n  \n  input:checked + .slider {\n    background-color: #5C60650F;\n  }\n  \n  input:focus + .slider {\n    box-shadow: 0 0 1px var(--secondary-200);\n  }\n  \n  input:checked + .slider:before {\n    // -webkit-transform: translateX(90px);\n    // -ms-transform: translateX(90px);\n    transform: translateX(85px);\n    background-color: #FF8787;\n  }\n  \n  /* Rounded sliders */\n  .slider.round {\n    border-radius: 34px;\n  }\n  \n  .slider.round:before {\n    border-radius: 15px;\n  }\n\n  .toggle-text {\n    margin-top: -4px;\n    margin-left: 10px;\n    font-size: 13px;\n    font-weight:600\n  }\n\n  .toggle-checkbox{\n    display: none;\n    visibility: hidden !important;\n  }\n\n  .toggle-btn-dis-text{\n    position: absolute;\n    top: 6px;\n    margin-left: 104px;\n    font-weight:600;\n  }\n\n  .team-mates-scroll{\n    overflow-y: scroll;\n    height: 470px;\n  }\n\n  .team-leads-scroll{\n    overflow-y: scroll;\n    height: 330px;\n  }\n\n /* width */\n::-webkit-scrollbar {\n    width: 6px;\n    margin-left: 4px;\n  }\n  \n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: #fff; \n  }\n   \n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #E3E9F4; \n    border-radius: 20px;\n  }\n  \n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #E3E9F4; \n  }\n\n\n///roleInfo pop up\n    .permissions-tab{\n        min-width: 615px;\n        overflow: scroll;\n    }\n\n    .permission-badge{\n        background-color: #EFF3F9;\n        padding: 8px;\n        width: 315px;\n        border-radius: 15px;\n        height: 37px;\n    }\n\n    .permission-text{\n        font-size: 11px;\n        font-weight: 500;\n    }\n\n    .team-label-img{\n        height: 40px;\n        min-width: 40px;\n    }\n\n    .team-label-heading{\n        color: var(--text-high-emphasis, #090826);\n        font-family: Inter;\n        text-align: left;\n        font-size: 0.6rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 120%;\n    }\n\n    .project-info{\n        margin-left: 360px;\n    }\n\n    .permission-info{\n        width: 80px;\n        background-color: #F0FBE6;\n        padding: 8px;\n        border-radius: 15px;\n        height: 37px;\n    }\n\n    .permission-rejected{\n        width: 80px;\n        background-color: #FFF0F0;\n        padding: 8px;\n        border-radius: 15px;\n        height: 37px;\n    }\n\n    .permission-table{\n        height: 15px;\n        min-width: 16px;\n        margin-left: 22px;\n        margin-top: 2px;\n    }\n\n    .permission-warning{\n        height: 10px;\n        min-width: 12px;\n        margin-top: -3px;\n        margin-left: 15px;\n    }\n\n    .permission-approval{\n        position: absolute;\n        //top: 245px;\n        //right: 290px;\n        z-index: 1000;\n        width: 275px;\n        border-radius: 14px;\n        border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n        background: #FFF;\n    }\n\n    //accordion css\n\n    .team-mate-accordion{\n        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFLSURBVHgBnZLfTcMwEMbv7Lhx/RQ2sASuEC+UDdoNwgSUDViBDWCCZgPYoGWC8ogEEt6APiGranLYSaiqJqmqfJJj6/78fPlkhD0liU6cEykA6ipSLJ37WsIR4f9BqfOUcj73keSgxhJsps5Z2wZgu+aCv9TEx20e3RCwKUN69iGNJFZCmDF0aShH32FJqfVhLjT6HA2lWbQ2KzVKQ4GUZtZ5wdA8VTXNC1hRQDlansN7F4CI1zkxaQCIcA0ni9sGADEv6Zxj2tXGoJhUJ2dbC0oTY/PT5nQcXzzUHs3beqPw2eZ0GzFcRBxWnJvMh97q/B0CTqop2rV7SFJeaobFKxFc7xcQUMYAkUoYZb/u874xQfl37sP6bSzElV9bHWKDwWa5XtvSZCVHHoYzJQ0cQk6Wh2TBD9XhRy8IQg8FSPAklpsz6Ktgetj/ANwtaoEESpAOAAAAAElFTkSuQmCC);\n        background-repeat: no-repeat;\n        background-position: 12px 14px;\n        min-width: 394px;\n        flex: 1 1;\n        padding: 9px;\n        box-sizing: border-box;\n        border: 1px solid #ccc;\n        border-radius: 10px;\n        margin-right: 12px;\n        padding-left: 36px;\n    }\n\n    .members-count{\n        font-size: 11px;\n        font-weight: 500;\n        margin: 2px;\n        margin-right: 9px;\n    }\n\n    .accordion-btn {\n        padding: 14px 20px;\n        background-color: white;\n        color: black;\n        border-bottom: 2px solid #E3E9F4;\n        cursor: pointer;\n        margin-right: 10px;\n        width: 599px;\n        text-align: left;\n        justify-content: space-between;\n     }\n\n     .accordion-label{\n        font-weight: 700;\n        font-size: 13px;\n        margin: 7px;\n     }\n\n     .accordion-content {\n        font-size: 20px;\n        margin-top: 20px;\n     }\n     .accordion-btn:hover {\n        background-color: #EFF3F9;\n        border-bottom: 2px solid #E3E9F4;\n     }\n     .accordion-btn:active {\n        border:none;\n     }\n     .accordion-btn:focus {\n        border:none;\n     }\n\n     //notification side pop-up\n\n     .notification {\n        z-index:9999999999;\n        box-shadow: 10px 14px 74px 0px #5C606533;\n        width: 400px;\n        //height: 129px;\n        position: fixed;\n        bottom: 20px;\n        left: 20px;\n        background-color: white;\n        color: black;\n        padding: 0px 0px;\n        border-radius: 14px;\n        transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n      }\n\n      .notification-message{\n        color: #090826;\n    font-weight: 600;\n    font-size: 14px;\n    margin-bottom: 5px;\n    padding: 5px;\n    border-radius: 5px;\n      }\n\n      .msg-container {\n        //display: flex;\n        padding: 20px 20px;\n        //justify-content: space-between;\n      }\n\n      .notification-icon {\n        display: flex;\n        //height: 129px;\n        border-bottom-left-radius: 14px;\n        border-top-left-radius: 14px;\n        width: 95px;\n        align-items: center;\n        //background: #E3E9F4;\n        justify-content: center;\n      }\n      \n      .notification.show {\n        transform: translateX(0);\n        opacity: 1;\n      }\n\n\n///task popup css\n\n    .overlay{\n        position: fixed;\n        top:0;\n        z-index: 20000000000!important;\n        bottom: 0;\n        left: 0;\n        right:0;\n        background: var(--foundation-neutral-neutral-900, #5c6065c1);\n        width:100vw;\n        height: 100vh;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        .taskPopUp, .memberPopup, .modalPopup{\n        background:white;\n        /* height: 48vh !important; */\n        overflow-x: hidden;\n max-height: 95vh;\n min-width: auto;\n            &.h-auto{\n                height: auto!important;\n                min-height: auto;\n            }\n .scrollable{\n    max-height: 65vh;\n    overflow-y: auto;\n    scroll-behavior: smooth;\n    height: -webkit-fill-available;\n }\n .title{\n    overflow: hidden;\ncolor: var(--text-high-emphasis, #090826);\ntext-overflow: ellipsis;\n\n/* Typography/Heading 3/Bold */\nfont-family: Inter;\nfont-size:1.8rem;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 42px */\n}\n.title-text-small-color{\n    color: var(--text-high-emphasis, #090826); \n} \n    }\n    .border-right{\n        border-right: 1px solid #E3E9F4;\n    }\n    .play-pause{\nbackground: var(--foundation-secondary-secondary-50, var(--secondary-200));\n        &.on {\n            background: var(--foundation-secondary-secondary-500, var(--secondary-700));\n            .play-pause-button{\n                background: var(--foundation-secondary-secondary-50, var(--secondary-200));\n                i {color: #000000;}\n            }\n        }\n    }\n    .play-pause-button{\n        border-radius: 50px;\nbackground: var(--foundation-secondary-secondary-500, var(--secondary-700));\nbox-shadow: 0px 4px 8px 0px rgba(92, 96, 101, 0.06);\n    }\n    .sum-title{\n        color: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Large/Bold */\nfont-family: Inter;\nfont-size: 0.9rem;\nfont-style: normal;\nfont-weight: 500;\nline-height: 120%; /* 19.2px */\n    }\n    .uploadedFile{\n    \nborder: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);\nbackground: var(--foundation-neutral-neutral-50, #FCFCFE);\nposition: relative;\n/* org */\n\n.orgCreate{\n    border-radius: 24px;\n    background: var(--foundation-neutral-dark-theme-neutral-dark-theme-700, #343535);\n    \n    /* modal page */\n    box-shadow: 10px 14px 114px 0px rgba(31, 32, 32, 0.40);\nmin-height: 80vh;\nmin-width: auto;\n    height: 50vh !important;\n    overflow-x: hidden;\n}\n\n\n\n/* card */\nbox-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);\n.filename{\n    color: var(--text-high-emphasis, #090826);\n\n    /* Typography/Body/Default/Regular */\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 130%; /* 18.2px */\n}\n.fileDetail{\n    color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n\n/* Typography/Body/Extra Small/Regular */\nfont-family: Inter;\nfont-size: 10px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 12px */\n}\n.document-svg{\n    box-shadow: 2px 4px 10px 0px rgba(92, 96, 101, 0.24);\n}\n.pdf{\n    border-radius: 1px;\nbackground: var(--foundation-red-red-500, #FF6969);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\n}\n.default{\n    border-radius: 1px;\n    background: var(--foundation-red-red-500, #48792f);\n    color: #FFF;\n    text-align: center;\n    font-family: Inter;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;  \n}\n.png{\n    border-radius: 1px;\nbackground: var(--foundation-dark-blue-dark-blue-500, #6C9BF6);\ncolor: #FFF;\ntext-align: center;\nfont-family: Inter;\nfont-size: 8px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;  \n}\n.svg{\n    border-radius: 1px;\n    background: var(--foundation-red-red-500, #f09409);\n    color: #FFF;\n    text-align: center;\n    font-family: Inter;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n}\n\n    }\n    }\n\n    .alert {\n        height: auto;\n        align-items: flex-end;\n        left: -175px;\n    }\n    .popup{\n        border-radius: 14px;\n    border: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n    background: var(--foundation-neutral-neutral-50, #FCFCFE);\n    \n    /* card */\n    box-shadow: 10px 14px 14px 0px rgba(92, 96, 101, 0.08);\n    .description-txt{\n        border-radius: 14px;\n        border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n    }\n    .link-txt{\n        border-radius: 14px;\n        border: 1px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n    }\n    .icon-color{\n        color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60)); \n    }\n    .input-custom{\n        border-radius: 14px;\n    //border: 2px solid var(--foundation-neutral-dark-theme-neutral-dark-theme-400, #6D6F6F);\n    color: black ;\n    }\n   \n      \n      \n    }\n    .btn-popup{\n    \n        border: 2px solid var(--primary);\n        background: var(--foundation-secondary-secondary-400, var(--primary));\n        box-shadow: 0px 10px 10px 0px var(--primary-opactiy-40);\n        font-weight:600;\n    }\n    .btn-popup:hover{\n        background: var(--secondary-300);\n        border: 2px solid var(--secondary-300);\n    }\n       \n      .border-btn-select{\n        border:2px solid rgba(9, 8, 38, 0.60);\n      }\n    .bg-btn-teal{\n        background:  var(--foundation-secondary-secondary-500, var(--secondary-700)); \n      }  \n    .sidebar-data-todo{\n      \n        border-radius: 14px;\n        background: var(--foundation-neutral-neutral-100, #F4F7FB);\n      }\n   \n  .sidebar-txt{\n    margin-top: 5px;\n    color: var(--text-high-emphasis, #090826);\n    font-family: Inter;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 130%;\n  }\n  .task-tab{\n    border-radius: 14px;\n    background: var(--foundation-secondary-secondary-50, var(--secondary-200));\n    color: var(--foundation-secondary-secondary-800, var(--secondary-500));\n\n    /* Typography/Body/Default/Bold */\n    font-family: Inter;\n\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; /* 16.8px */\n  }\n  .comment-box{\n    border-radius: 14px;\nborder: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);\n  }\n  .todo-hover:hover{\n    border-radius: 14px;\n    background: var(--foundation-neutral-neutral-400, #E3E9F4);\n  }\n  .dropdown-task{\n    border-radius: 14px;\nborder: 2px solid var(--foundation-neutral-neutral-400, #E3E9F4);\nbackground-color: transparent;\ncolor: var(--text-high-emphasis, #090826);\n\n/* Typography/Body/Default/Regular */\nfont-family: Inter;\n\n  }\n  .progress-estimated{\n    font-size: 10px;\n    color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60)); \n  }\n //custom member\n .active-status{\n    border-radius: 54px;\nborder: 2px solid rgba(106, 218, 0, 0.50);\nbackground: rgba(106, 218, 0, 0.20);\ncolor: var(--foundation-green-green-800, #3A7800);\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n }\n .unactive-status\n {\n    border-radius: 54px;\nborder: 2px solid rgba(255, 105, 105, 0.50);\nbackground: rgba(255, 105, 105, 0.20);\ncolor: var(--foundation-red-red-800, #8C3A3A);\n\n/* Typography/Body/Small/Regular */\nfont-family: Inter;\nfont-size: 0.8rem;\nfont-style: normal;\nfont-weight: 400;\nline-height: 120%; /* 14.4px */\n }\n .rdt_TableRow{\n    border-bottom: none !important;\n }\n .shift-table .rdt_TableRow{\n    border-bottom: 2px solid var(--neutral-400) !important;\n }\n .dropdown-custom{\n    background-color: white;\n    border: 1px solid var(--main-neutral-neutral-400, #E3E9F4);\nbackground: #FFF;\n/* popover */\nbox-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\nz-index: 100000 !important;\ndisplay: block;\n }\n .member-section-title{\ncolor: var(--main-secondary-secondary-800, var(--secondary-500));\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 16.8px */\n }\n .dropdown-container{\n    border: 2px solid #E3E9F4  !important;\n    box-shadow: none !important;\n    border-radius: 14px !important;\n }\n .dropdown-container:focus-within{\n    border: 2px solid #E3E9F4  !important;\n    box-shadow: none !important;\n\n }\n\n .rmsc .gray{\n    color: var(--text-low-emphasis, rgba(9, 8, 38, 0.32)) !important;\n\n  \n }\n select, option{\n    background-color: white !important;\n }\n.dropdown-menu{\n    position: absolute;\n    /* top: 8px; */\n    z-index: 100000000000000 !important;\n    border-radius: 14px;\n    border: 1px solid var(--main-neutral-neutral-400, #E3E9F4);\n    background: #FFF;\n    box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);\n}\n.dropdown,.btn-simple{\n    border: 2px solid var(--main-neutral-neutral-400, #E3E9F4);\n}\n\n.invite-link{\n    color: var(--main-secondary-secondary-800, var(--secondary-500));\n\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 120%; /* 16.8px */\n}\n.btn-green{\n    background: var(--main-secondary-secondary-400, var(--primary));\n    box-shadow: 0px 10px 31px 0px var(--primary-opactiy-40);\n\n        }\n       .navtab-active{\n        border-radius: 14px;\n        background: var(--main-secondary-secondary-50, var(--secondary-200));\n        color: var(--main-secondary-secondary-800, var(--secondary-500));\n\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 120%; /* 16.8px */\n        }\n        .navtab-unactive{\n            color: var(--text-medium-emphasis, rgba(9, 8, 38, 0.60));\n\n/* Typography/Body/Default/Bold */\nfont-family: Inter;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 120%; /* 16.8px */\n        }\n       .txt-green{\n        color: var(--main-secondary-secondary-800, var(--secondary-500)); \n       }\n       .online{\n    background-color: var(--main-green-green-500, #6ADA00);\n       }\n       .multi-dropdown{\n        border-radius: 14px;\nborder: 1px solid var(--main-neutral-neutral-400, #E3E9F4);\nbackground: #FFF;\nbox-shadow: 10px 14px 74px 0px rgba(92, 96, 101, 0.20);\n       }\n       .btn-red{\nborder: 2px solid rgba(255, 255, 255, 0.80);\nbackground: var(--main-red-red-500, #FF6969);\nbox-shadow: 0px 10px 31px 0px rgba(255, 105, 105, 0.40);\n       }\n\n //team pop up css \n\n.form-steps-active {\n    background-color: #C8CFDB;\n    height: 40px;\n    width: 40px;\n    box-shadow: 0 0 0 3px #fff inset;\n    box-sizing: border-box;\n    border: 2.5px solid #C8CFDB;\n    //border-radius: 999999px;\n}\n\n.form-steps-complete {\n    background-color: var(--primary);\n    height: 40px;\n    width: 40px;\n    box-shadow: 0 0 0 3px #fff inset;\n    box-sizing: border-box;\n    //border-radius: 999999px;\n}\n\n.divider{\n    background: var(--primary);\n}\n\n.form-steps{\n    background-color: #C8CFDB;\n    height: 40px;\n    width: 40px;\n    box-shadow: 0 0 0 3px #fff inset;\n    box-sizing: border-box;\n}\n\n.check-icon{\n    height:11px\n}\n\n.multiselect-wrapper {\n    position: relative;\n  }\n  \n  .pill-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: calc(100% - 30px);\n    padding: 3px;\n    box-sizing: border-box;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n  \n  .pill {\n    background-color: #e0e0e0;\n    padding: 5px 10px;\n    margin: 5px;\n    border-radius: 20px;\n  }\n  \n  .custom-input {\n    flex: 1 1;\n    padding: 10px;\n    box-sizing: border-box;\n    border: 2px solid #E3E9F4;\n    border-radius: 12px;\n    &:disabled{\n        background-color: rgba(221, 221, 221, 0.7) !important;\n        opacity: 1;\n    }\n  }\n\n  .custom-logo-upload:hover{\n    background-color: #ededed;\n  }\n\n.rmsc .dropdown-container{\n    width: 215px;\n    height: 39px;\n    box-sizing: border-box;\n    border: 2px solid #E3E9F4 !important;\n    border-radius: 12px !important;\n    font-weight: 500;\n}\n\n.error-text{\n    font-size: 12px;\n      color: var(--red-300);\n      width:0px !important;\n  }\n\n.cancel-btn-popup{\n    \n    border: 2px solid #E3E9F4;\n    background: var(--foundation-secondary-secondary-400, #fff);\n    border-radius: 11px;\n    margin-right:5px;\n    font-weight:600;\n}\n\n.cancel-btn-popup:hover{\n    background: #ededed;\n}\n\n//permissionPage \n\n.permission-page{\n    overflow: scroll;\n    height: 43vh;\n}\n\n.value-text{\n    color: var(--text-high-emphasis, #090826);\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 60%;\n}\n\n.info-box{\n    padding-left: 15px;\n    padding-right: 15px;\n    border-left: 3px solid #DCE4F1;\n}\n\n//addRoleInfoPopup css\n \n.role-info{\n    width:420px;\n}\n\n //input-type file\n input[type=\"file\"]{\n    display: none;\n }\n .custom-file-upload{\n    border: 2px solid #E3E9F4;\n    display: inline-block;\n    padding: 8px 18px;\n    cursor: pointer;\n    border-radius: 10px;\n    font-weight: 600;\n }\n .spacing-div {\n    margin-left: 12rem;\n }\n\n .modalPopup .spacing-div {margin-left: auto;}\n\n .spacing-div-sm {\n    margin-left: 18rem\n }\n\n select:invalid { color: rgba(0,0,0,0.35); }\n\n .info-icon, .info-icon:hover, .info-icon:focus {font-weight: normal; border: 1px solid var(--primary); font-style: italic; color: #000000; display: inline-block; font-size: 10px; width: 15px; height: 15px; line-height: 13px; text-align: center; border-radius: 50%; background-color: transparent; padding: 0; vertical-align: middle;}\n \n //settings\n\n .custom-logo-upload{\n    border: 2px solid #E3E9F4;\n    display: inline-block;\n    padding: 8px 28px;\n    cursor: pointer;\n    border-radius: 10px;\n    font-weight: 600;\n    width: 150px;\n    margin-top:5px;\n }\n\n .red-btn{\n    border-radius: 9px;\n    border: 2px solid rgba(255, 255, 255, 0.8);\n    background: #FF6969;\n    color: var(--text-high-emphasis, #090826);\n    font-family: Inter;\n    font-size: 0.82rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 143%;\n }\n\n .red-btn:hover{\n    background: #ff9c9c;\n    border: 2px solid #ff9c9c;\n }\n\n .edit-user-profile{\n    font-size:27px;\n    font-weight:400;\n }\n\n /* for actions dropdown */\n\n .btn-create {width: 30px; height: 30px; text-align: center; line-height: 30px; border-radius: 100%;}\n.btn-more-options i, .btn-create i {color: rgba(9, 8, 38, 0.6);} \n div:has( > .more-options-wrapper){overflow: unset !important;} \n .more-options-wrapper {position: relative; overflow: unset !important; }\n.more-options-wrapper .btn-more-options {width: 30px; height: 30px; text-align: center; line-height: 30px; border-radius: 100%;}\n.more-options-wrapper .btn-more-options:hover, .btn-create:hover {background-color: var(--primary-opactiy-10);}\n.more-options-wrapper .more-options {position: absolute; right: 0; top: 22px; background-color: #ffffff; border: 1px solid #E3E9F4; z-index: 9; padding: 13px 15px; text-align: center; border-radius: 14px; box-shadow: 10px 14px 74px 0px var(--primary-opactiy-10);}\n.items-row:last-of-type .more-options-wrapper .more-options {bottom: 22px; top: auto;}\n.more-options-wrapper .more-options > button { display: flex; align-items: center;}\n.more-options-wrapper .more-options > button:disabled {color: #bbbbbb;}\n.more-options-wrapper .more-options > button:not(:last-child) {margin-bottom: 15px;}\n.more-options-wrapper .more-options > button span {min-width: max-content; margin-left: 10px; padding: 4px 25px;} \n.more-options-wrapper .more-options > button span:hover {\n    background-color: var(--foundation-neutral-neutral-400, #E3E9F4);\n    padding: 4px 25px;\n    border-radius: 13px;\n}\n\n}\n\n.tooltip.show {left: 50%; transform: translateX(-50%); top: -18px; box-shadow: -3px 4px 16px 0 rgba(0, 11, 65, 0.15); padding: 2px 5px; border-radius: 5px; background-color: #ffffff; position: relative; z-index: 9999999999;}\n.tooltip.show:after {content: \"\"; width: 0; height: 0; font-size: 0; line-height: 0; position: absolute;}\n.tooltip.show.bs-tooltip-end:after{ border-bottom: 5px solid transparent; border-right: 5px solid #ffffff; border-top: 5px solid transparent;  bottom: 8px; left: -5px;}\n\n.checkbox-toggle-simple { position: relative; display: inline-block; width: 40px; height: 16px; background-color: #dddddd; border-radius: 40px; cursor: pointer; }\n.checkbox-toggle-simple:has(input:checked){background-color: var(--secondary-200);}\n.checkbox-toggle-simple input { opacity: 0; width: 0; height: 0; }\n.checkbox-toggle-simple input + span { position: absolute; width: 20px; height: 20px; border-radius: 50%; background-color: #bababa; top: -2px; left: 0; -webkit-transition: .4s; transition: .4s;}\n.checkbox-toggle-simple input:checked + span { background-color: var(--secondary-700); -webkit-transform: translateX(20px); -ms-transform: translateX(20px); transform: translateX(20px); -webkit-transition: .4s; transition: .4s;}\n\n.title-bdr-btm {border-bottom: 2px solid #E3E9F4; padding-bottom: 10px; margin-bottom: 10px; }\n.assignee-list > div {border: 1px solid #ffffff; border-radius: 50%;}\n.assignee-list > div:not(:first-child) {margin-left: -0.6em;}\nbutton.btn-remove{\n    position: absolute; top:-10px; right: -5px; border:2px solid var(--foundation-neutral-neutral-400, #E3E9F4); background-color: var(--foundation-neutral-neutral-50, #FCFCFE); border-radius: 50%; width: 16px; height: 16px; line-height: 12px;\n    & > i {font-size: 0.7em; line-height: 12px;}\n}\n\n.rdt_TableHeader {flex: none !important;}\n\n//make entire date field clickable to show calendar\ninput[type=\"date\"]{position: relative;}\ninput[type=\"date\"]::-webkit-calendar-picker-indicator { background: transparent; bottom: 0; color: transparent; cursor: pointer; height: auto; left: 0; position: absolute; right: 0; top: 0; width: auto; }\ninput[type=\"date\"]:before{ position: absolute; font-family: \"Font Awesome 5 Free\"; content: \"\\f133\"; display: inline-block; margin-right: 10px; vertical-align: middle; font-weight: 900; right: 0; top: 50%; transform: translateY(-50%); }\n\n.Navheader-collapse > div {background-color: (--foundation-neutral-dark-theme-neutral-dark-theme-500, #494B4B);}\n.org-selector.pb-3:after {content: \"\"; display: block; width: calc(100% - 30px); height: 15px; margin: 0 15px; border-bottom: 2px solid rgba(109, 111, 111, 0.6352941176);}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
